var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _mask, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _rect, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _g2, _path133, _path134, _path135, _g3, _path136, _path137, _path138, _g4, _path139, _path140, _path141, _g5, _path142, _path143, _path144, _g6, _path145, _g7, _path146, _path147, _path148, _g8, _path149, _path150, _path151, _path152, _path153, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWooblly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 243,
    viewBox: "0 0 239 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_412_8854)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_412_8854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.927 203.645C61.1347 203.841 60.2909 203.911 59.4436 203.837C57.2487 203.643 55.1366 202.572 53.6493 200.898C51.7964 198.812 51.0616 196.139 50.6696 194.307C49.4788 188.743 49.8889 182.978 50.2845 177.401C50.3896 175.922 50.4983 174.394 50.574 172.9C50.6216 171.965 50.6616 171.016 50.6925 170.08C51.3684 149.594 48.0546 130.596 40.8419 113.612C40.7012 113.281 40.8901 112.896 41.263 112.751C41.6363 112.608 42.0519 112.757 42.1925 113.088C49.4717 130.229 52.8164 149.393 52.1344 170.05C52.1034 170.993 52.0634 171.949 52.0152 172.891C51.9389 174.396 51.8296 175.931 51.7248 177.416C51.3345 182.911 50.9309 188.592 52.0869 193.995C52.6655 196.698 53.5255 198.621 54.7927 200.047C56.0363 201.448 57.8549 202.378 59.6579 202.536C61.3325 202.683 64.0197 201.269 64.9848 200.206C67.6055 197.322 64.7725 193.007 63.152 189.393C63.0051 189.065 63.1864 188.678 63.5567 188.527C63.927 188.377 64.3463 188.52 64.4932 188.848C65.6135 191.346 68.5898 197.984 65.0978 201.827C64.3012 202.705 63.1793 203.333 61.927 203.645Z",
    fill: "#FFF8E8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0061 183.954C12.6566 185.246 15.8451 185.441 18.7089 184.8C21.929 184.076 24.2384 182.171 26.6152 180.087C28.1007 178.79 29.6077 177.521 31.1514 176.288C32.6726 175.068 34.2756 173.519 36.0296 172.618C37.6958 171.762 39.9909 171.692 41.8317 171.424C43.4847 171.179 44.6139 171.451 45.7206 171.941C47.0325 172.815 48.5027 173.507 49.7197 174.531C51.3635 175.912 52.8939 177.595 53.8863 179.476C56.5326 184.488 53.5269 188.805 51.2675 193.219C50.0332 195.628 50.0658 200.194 52.6336 201.855C54.2916 202.927 57.3882 203.307 59.3699 202.333C60.7043 202.314 61.7426 201.349 62.635 200.185C62.7442 200.15 62.8535 200.092 62.9586 200.013C63.3864 199.672 63.7601 199.279 64.0694 198.838C64.343 198.448 64.4931 198.002 64.7984 197.644C65.2037 197.175 65.5774 196.725 65.7499 196.2C66.825 195.212 67.9767 194.325 68.9833 193.248C70.1768 191.966 71.4204 191.276 72.8732 190.694C73.01 190.89 73.2326 191.026 73.5338 191.001C75.1959 190.86 76.7029 190.586 78.2884 191.329C79.5953 191.946 80.2783 193.025 81.2207 194.013C82.0405 194.874 83.0472 195.515 83.8803 196.367C84.5817 197.085 85.1922 197.88 86.008 198.487C88.4716 200.328 93.6132 200.709 95.1395 197.538C96.1717 197.085 96.9793 196.415 97.5521 195.037C98.7721 192.103 100.65 189.442 101.63 186.417C102.116 184.904 102.408 183.337 102.954 181.839C103.304 180.875 103.875 180.106 104.428 179.337C105.236 178.75 105.892 177.992 106.802 177.503C108.158 176.778 109.739 176.494 111.274 176.432C112.978 176.367 114.7 176.572 116.362 176.905C117.039 177.039 117.682 177.263 118.328 177.42C119.567 177.84 120.792 178.309 121.914 179.035C124.386 180.64 126.289 183.635 127.468 186.229C128.545 188.59 128.913 191.179 130.042 193.542C131.054 195.648 132.369 197.85 134.227 199.372C137.288 201.887 142.04 204.046 145.9 201.966C147.494 201.106 148.757 199.625 149.243 197.928C149.365 197.517 149.48 196.969 149.439 196.494C149.966 195.999 150.476 195.487 150.905 194.898C151.726 193.768 152.193 192.456 152.964 191.306C153.835 190.013 155.05 189.239 156.234 188.253C156.791 187.791 157.251 187.204 157.805 186.759C158.597 186.118 159.308 185.857 160.265 185.668C161.418 185.936 162.601 185.79 163.785 185.993C165.246 186.241 166.637 186.811 167.792 187.719C170.001 189.452 170.648 191.796 171.378 194.316C172.037 196.612 172.93 198.886 173.942 201.064C174.624 202.533 175.555 203.74 177.288 204.037C180.955 204.668 184.549 201.815 185.541 198.589C186.383 195.85 187.721 190.777 185.476 188.29C185.345 187.835 185.199 187.384 185.045 186.941C183.936 183.841 181.242 180.665 181.273 177.268C181.273 177.189 181.26 177.12 181.237 177.052C181.32 176.607 181.443 176.165 181.618 175.736C183.15 171.971 187.421 171.209 191.187 170.773C196.007 172.622 199.668 177.635 204.519 179.464C206.837 180.337 209.391 180.194 211.487 178.842C213.913 177.281 214.543 174.233 216.861 172.628C218.437 171.537 219.995 172.144 221.598 172.752C222.726 173.179 223.878 173.607 225.076 173.441C227.19 173.152 228.847 171.512 229.516 169.622C230.424 167.068 229.963 163.959 229.075 161.462C228.591 160.098 227.859 158.379 226.524 157.63C225.75 156.734 224.799 155.937 224.044 155.33C221.921 153.625 219.752 153.944 217.151 154.454C213.512 155.173 209.942 156.26 206.605 154.044C203.989 152.304 203.197 149.95 202.491 147.31C202.98 146.282 203.171 145.163 203.607 144.104C204.018 143.121 204.537 142.178 204.927 141.189C205.802 138.956 205.815 136.598 205.507 134.258C204.914 129.754 202.878 126.553 199.085 123.841C196.106 121.716 191.08 121.799 188.516 124.537C187.831 125.267 187.35 126.118 186.781 126.93C185.933 128.135 184.899 128.914 183.756 129.842C182.949 130.493 182.254 131.604 181.168 131.854C180.158 132.089 178.759 131.688 177.606 131.57C176.564 130.699 175.748 129.602 175.466 128.669C174.783 126.405 175.458 123.823 175.089 121.506C175.066 121.374 175.003 121.282 174.919 121.227C174.961 120.661 175.011 120.092 175.058 119.529C176.391 117.802 176.741 115.178 177.376 113.136C178.1 110.787 178.819 108.433 179.606 106.098C180.348 103.899 181.114 101.472 181.401 99.0351C181.548 98.9747 181.674 98.8547 181.733 98.6769C182.88 95.2078 182.133 90.7571 181.984 87.1608C181.838 83.6755 181.532 80.1459 180.476 76.7923C179.292 72.9993 177.499 69.3137 175.926 65.6569C175.108 63.7496 174.245 61.7331 173.095 59.9358C168.257 51.8888 160.165 45.0616 152.002 40.3077C147.823 37.8708 143.396 35.8642 138.856 34.1337C136.402 33.2008 133.914 32.3392 131.391 31.6002C129.204 30.9578 126.864 30.1702 124.565 30.5166C123.025 30.1657 121.467 29.877 119.896 29.6712C114.157 28.9188 108.26 29.1958 102.709 30.8523C96.6005 32.6721 90.7626 35.608 85.0238 38.2804C82.6378 39.3883 79.7188 40.3357 77.8596 42.2204C77.0041 43.0884 76.3251 44.1097 75.4869 45.0011C75.4553 45.0129 75.4185 45.0264 75.3868 45.0453C68.3003 49.2074 63.9153 56.2015 59.2515 62.5343C56.7971 65.8716 55.7169 69.8469 54.5744 73.7292C53.968 75.7809 53.3166 77.8362 52.8704 79.924C52.7204 80.6449 52.5652 81.3793 52.557 82.0929C51.4319 84.7473 51.4687 87.7175 51.5279 90.5676C51.5952 93.8265 51.486 97.2198 52.1282 100.434C52.4386 102.01 53.1257 103.361 53.8087 104.805C54.6245 106.523 55.1891 108.267 55.7077 110.082C56.3407 112.3 56.8512 115.378 58.545 117.194C58.5501 117.273 58.5634 117.351 58.5725 117.43C58.7277 119.245 58.6042 121.042 58.1264 122.805C57.6026 124.743 56.7971 127.147 54.6704 127.939C53.9322 128.213 52.4794 128.438 51.2818 128.306C50.3793 127.502 49.4277 126.768 48.4935 126.117C45.8574 124.271 43.3162 124.673 40.6515 126.285C37.9653 127.908 37.1179 129.657 37.5957 132.637C37.901 134.535 38.3063 136.425 39.021 138.222C39.7275 140.014 40.0277 141.472 40.0277 143.338C39.8633 143.548 39.6867 143.744 39.4907 143.911C37.0352 146.001 32.6818 145.384 29.9313 144.199C28.2416 143.474 26.7388 142.455 24.9215 142.301C24.6029 142.206 24.2752 142.137 23.9464 142.118C21.9658 142.005 19.493 143.818 18.3127 145.25C16.6506 147.267 17.3163 149.74 18.0218 151.971C18.5864 153.764 19.0417 155.603 18.6456 157.487C18.618 157.625 18.5772 157.753 18.5363 157.875C16.5005 159.494 14.0502 160.342 11.7551 161.61C9.37825 162.931 7.79677 164.772 6.9412 167.283C5.20147 172.369 4.00388 181.028 10.0061 183.954Z",
    fill: "#FFBF08"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.912 119.567C124.405 119.567 129.632 114.297 129.632 107.847H106.15C106.192 114.297 111.42 119.567 117.912 119.567Z",
    fill: "#060000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.248 116.995C123.519 115.14 120.905 113.959 117.912 113.959C114.919 113.959 112.305 115.14 110.576 116.995C112.6 118.597 115.129 119.567 117.912 119.567C120.694 119.567 123.224 118.597 125.248 116.995Z",
    fill: "#FF5F3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M183.825 220.993C183.795 220.993 183.795 221.039 183.825 221.039C183.857 221.039 183.857 220.993 183.825 220.993Z",
    fill: "#FFBF08"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6201 33.759C95.8667 33.2258 97.1235 32.7133 98.3885 32.2396C101.575 31.5539 104.805 31.0776 108.034 30.6598C110.37 30.3576 112.683 30.1401 114.983 30.1401C115.573 30.1401 116.162 30.1537 116.75 30.1843C117.338 30.1537 117.926 30.1401 118.517 30.1401C120.42 30.1401 122.33 30.2881 124.257 30.5119C124.277 30.5164 124.296 30.5209 124.317 30.5254C124.324 30.5236 124.332 30.5236 124.34 30.5209C124.716 30.5651 125.093 30.6111 125.469 30.6598C127.053 30.8655 128.637 31.0848 130.218 31.3338C130.53 31.4267 130.838 31.5188 131.143 31.609C132.562 32.0249 133.971 32.4796 135.37 32.965C131.951 32.2811 128.509 31.8372 125.224 31.461C122.528 31.1515 120.462 31.0153 118.517 31.0153C117.949 31.0153 117.388 31.027 116.85 31.0523C116.818 31.055 116.784 31.055 116.75 31.055C116.716 31.055 116.684 31.055 116.651 31.0523C116.113 31.027 115.55 31.0153 114.983 31.0153C113.041 31.0153 110.971 31.1515 108.277 31.461C103.862 31.9672 99.1675 32.5951 94.6201 33.759Z",
    fill: "#FFBF08"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M173.871 62.2887C172.643 59.8192 171.085 57.4843 169.462 55.2945C169.177 54.8831 168.887 54.4771 168.592 54.0747C170.187 55.9432 171.621 57.9047 172.847 59.9437C172.952 60.108 173.054 60.274 173.156 60.4427C173.424 61.0454 173.667 61.6625 173.871 62.2887Z",
    fill: "#FFBF08"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6282 62.2862C59.7629 61.8775 59.913 61.4705 60.0764 61.069C60.3878 60.6396 60.6992 60.2074 61.0116 59.7734C60.5185 60.5954 60.0539 61.4336 59.6282 62.2862Z",
    fill: "#FFBF08"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2503 79.5189C61.2886 85.517 59.0302 90.1644 57.2068 89.8947C55.3833 89.624 54.685 84.5426 55.6467 78.5418C56.6085 72.5411 58.8658 67.8963 60.6893 68.167C62.5127 68.4368 63.2121 73.5182 62.2503 79.5189Z",
    fill: "#FFF8E8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3588 91.2286C64.1117 94.4135 63.057 96.9308 62.0034 96.8568C60.9498 96.781 60.2964 94.1384 60.5434 90.9562C60.7905 87.7731 61.8452 85.2531 62.8988 85.3298C63.9535 85.4029 64.6069 88.0456 64.3588 91.2286Z",
    fill: "#FFF8E8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3729 76.6377C66.8552 78.7534 65.868 80.3404 65.1665 80.1834C64.4662 80.0237 64.3181 78.1805 64.8358 76.0647C65.3534 73.949 66.3407 72.3602 67.041 72.5198C67.7414 72.6768 67.8905 74.5201 67.3729 76.6377Z",
    fill: "#FFF8E8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M175.252 85.5413C175.429 88.7289 176.43 91.2696 177.487 91.2137C178.539 91.1613 179.251 88.5322 179.073 85.3446C178.895 82.1579 177.894 79.6172 176.838 79.6723C175.785 79.7255 175.074 82.3537 175.252 85.5413Z",
    fill: "#FFF8E8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M172.554 70.8933C173.027 73.0181 173.978 74.625 174.684 74.4824C175.387 74.3363 175.575 72.4984 175.102 70.3709C174.632 68.2462 173.678 66.6384 172.975 66.7818C172.271 66.9244 172.083 68.7659 172.554 70.8933Z",
    fill: "#FFF8E8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M171.352 134.264C171.375 134.192 171.506 134.174 171.522 134.264C171.684 135.16 171.472 136.031 171.948 136.879C172.364 137.62 172.985 138.154 173.592 138.74C173.652 138.798 173.592 138.885 173.513 138.872C172.69 138.708 171.998 137.74 171.6 137.073C171.119 136.264 171.036 135.137 171.352 134.264Z",
    fill: "#FF5F3D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M177.188 152.448C178.202 152.922 179.237 153.248 180.008 154.084C180.082 154.16 179.993 154.266 179.898 154.222C178.897 153.772 178.11 153.017 177.146 152.518C177.096 152.493 177.141 152.426 177.188 152.448Z",
    fill: "#FF5F3D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M183.443 156.189C184.259 156.607 185.171 156.866 185.973 157.295C186.025 157.323 185.988 157.39 185.934 157.382C185.045 157.253 184.13 156.75 183.349 156.343C183.244 156.288 183.338 156.136 183.443 156.189Z",
    fill: "#FF5F3D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M186.326 157.567C186.498 157.641 186.668 157.715 186.838 157.787C187.008 157.859 187.201 157.9 187.358 157.997C187.421 158.038 187.382 158.148 187.303 158.121C187.134 158.069 186.99 157.96 186.833 157.88C186.655 157.791 186.474 157.704 186.297 157.616C186.263 157.6 186.291 157.554 186.326 157.567Z",
    fill: "#FF5F3D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M189.776 159.267C190.518 159.334 191.103 159.672 191.794 159.91C192.447 160.134 193.137 160.356 193.72 160.723C193.793 160.769 193.73 160.871 193.652 160.834C192.962 160.52 192.332 160.28 191.593 160.09C190.963 159.926 190.375 159.6 189.748 159.461C189.637 159.439 189.659 159.258 189.776 159.267Z",
    fill: "#FF5F3D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M195.453 161.418C195.994 161.569 196.508 161.871 196.94 162.213C196.979 162.245 196.935 162.303 196.89 162.293C196.357 162.171 195.795 161.995 195.317 161.73C195.144 161.633 195.26 161.363 195.453 161.418Z",
    fill: "#FF5F3D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M197.648 162.468C197.81 162.491 197.957 162.537 198.08 162.641C198.112 162.667 198.08 162.727 198.04 162.711C197.904 162.655 197.782 162.604 197.633 162.589C197.541 162.579 197.557 162.454 197.648 162.468Z",
    fill: "#FF5F3D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M198.872 162.77C199.321 162.911 199.742 163.096 200.176 163.274C200.553 163.431 201.004 163.543 201.297 163.823C201.367 163.89 201.295 163.996 201.203 163.976C200.803 163.894 200.458 163.608 200.095 163.432C199.68 163.234 199.243 163.075 198.817 162.895C198.743 162.865 198.795 162.747 198.872 162.77Z",
    fill: "#FF5F3D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M161.656 145.975C162.185 146.982 162.844 147.968 163.281 149.014C163.326 149.121 163.15 149.218 163.08 149.128C162.353 148.236 161.901 147.092 161.512 146.032C161.483 145.952 161.616 145.899 161.656 145.975Z",
    fill: "#FF5F3D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M164.708 151.356C164.935 151.629 165.149 151.911 165.361 152.197C165.563 152.47 165.852 152.768 165.91 153.105C165.926 153.2 165.824 153.262 165.743 153.198C165.489 152.992 165.361 152.639 165.194 152.366C165.003 152.052 164.792 151.752 164.574 151.456C164.519 151.38 164.648 151.282 164.708 151.356Z",
    fill: "#FF5F3D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M147.557 153.413C148.023 154.187 148.566 155.1 148.812 155.966C148.827 156.016 148.752 156.07 148.713 156.023C148.14 155.314 147.703 154.358 147.335 153.536C147.272 153.395 147.474 153.273 147.557 153.413Z",
    fill: "#FF5F3D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M150.037 157.698C150.926 158.813 151.731 160.024 152.248 161.343C152.259 161.37 152.218 161.382 152.201 161.361C151.362 160.215 150.646 158.978 149.909 157.77C149.857 157.689 149.98 157.627 150.037 157.698Z",
    fill: "#FF5F3D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M183.523 169.629C183.409 169.454 183.27 169.293 183.118 169.142C183.351 169.251 183.582 169.369 183.816 169.472C183.714 169.521 183.622 169.579 183.523 169.629ZM182.037 168.631C182.227 168.726 182.423 168.812 182.614 168.905C182.604 168.932 182.604 168.963 182.622 168.994C182.726 169.177 182.813 169.367 182.888 169.563C182.667 169.23 182.371 168.92 182.037 168.631ZM107.45 174.371C109.023 172.011 110.469 169.533 111.503 166.967C111.36 167.433 111.217 167.9 111.088 168.371C111.069 168.436 111.069 168.493 111.078 168.547C110.529 169.408 110.262 170.411 109.816 171.325C109.358 172.265 108.812 173.166 108.258 174.057C108.166 174.09 108.077 174.12 107.986 174.154C107.918 174.185 107.85 174.222 107.782 174.251C107.67 174.286 107.559 174.33 107.45 174.371ZM175.86 164.426C175.304 163.915 174.771 163.368 174.263 162.742C174.213 162.679 174.159 162.62 174.107 162.555C174.622 162.984 175.126 163.409 175.604 163.834C176.229 164.389 176.843 164.957 177.473 165.509C176.929 165.153 176.391 164.795 175.86 164.426ZM229.822 163.073C229.388 160.527 228.162 158.178 225.865 156.474C223.568 154.767 221.051 153.727 218.118 154.413C214.509 155.249 211.631 157.593 207.82 155.667C207.77 155.642 207.721 155.628 207.674 155.621C206.895 155.016 206.135 154.364 205.152 153.972C205.11 153.954 205.073 153.944 205.037 153.944C203.694 152.358 203.189 150.244 203.166 148.181C203.184 148.147 203.194 148.103 203.189 148.06C203.178 147.996 203.173 147.937 203.166 147.875C203.166 147.814 203.16 147.752 203.16 147.692C203.173 147.183 203.215 146.675 203.275 146.169C203.33 146.103 203.374 146.029 203.393 145.934C203.785 143.507 204.778 141.236 205.152 138.8C205.465 136.757 205.525 134.693 205.233 132.642C204.713 128.965 202.345 125.881 199.14 123.839C196.56 122.197 192.842 121.643 190.371 123.798C189.825 124.28 189.31 124.914 188.806 125.618C188.409 126.008 188.064 126.436 187.789 126.899C187.727 127.009 187.703 127.12 187.714 127.223C187.591 127.419 187.457 127.613 187.33 127.805C187.181 127.986 187.039 128.172 186.903 128.374C186.747 128.168 186.438 128.094 186.182 128.304C185.066 129.244 184.775 130.722 183.714 131.702C183.272 132.113 182.763 132.388 182.23 132.549C181.655 132.676 181.04 132.7 180.367 132.573C180.225 132.545 180.107 132.573 180.008 132.626C179.328 132.494 178.665 132.226 178.077 131.863C175.727 130.404 175.33 127.648 175.207 124.946C175.23 124.452 175.252 123.96 175.267 123.475C175.27 123.318 175.22 123.209 175.144 123.135C175.126 122.505 175.097 121.897 175.042 121.329C175.011 121.026 174.595 121.036 174.561 121.329C174.483 121.945 174.409 122.588 174.355 123.244C174.279 123.336 174.238 123.445 174.273 123.567C173.759 127.669 173.722 132.279 178.359 134.143C178.79 134.317 179.274 134.422 179.779 134.484C181.139 135.436 180.816 136.545 180.112 137.534L180.074 137.568C178.795 138.661 176.192 140.273 174.381 139.204H174.329L174.303 139.181C174.216 139.079 174.054 139.247 174.183 139.33C174.389 139.465 174.603 139.576 174.815 139.675C175.419 140.06 176.078 140.19 176.746 140.143C178.268 140.208 179.804 139.634 181.111 138.769C182.34 137.959 182.734 137.106 183.435 135.935C184.068 134.88 184.954 134.256 185.202 133.212C185.86 132.721 186.375 132.099 186.641 131.344C186.835 131.129 187.015 130.904 187.181 130.679C188.149 129.332 188.714 128.107 190.335 127.297C191.835 126.553 193.511 126.122 195.204 126.297C196.145 126.394 197.068 126.742 197.927 127.256C198.093 127.475 198.234 127.708 198.349 127.96C198.385 128.038 198.411 128.115 198.438 128.193C198.455 128.357 198.466 128.526 198.461 128.708C198.432 129.6 198.135 130.454 197.935 131.316C197.642 132.037 197.347 132.752 197.052 133.471C196.681 134.372 196.394 135.49 195.682 136.19C195.648 136.222 195.698 136.268 195.732 136.238C196.406 135.629 196.702 134.746 197.083 133.954C197.269 133.571 197.455 133.187 197.64 132.805L197.661 132.787V132.768C197.708 132.669 197.755 132.573 197.802 132.475L197.82 132.469C198.081 132.069 198.317 131.568 198.508 131.014C198.934 130.11 199.206 129.198 199.303 128.258C199.765 128.662 200.194 129.105 200.576 129.576C201.516 131.156 202.02 133.032 202.193 135.004C202.042 135.931 202.159 136.822 202.221 137.725C202.164 138.624 202.062 139.532 201.968 140.442C201.673 141.529 201.221 142.585 200.973 143.686C200.539 145.595 200.437 147.285 198.617 148.516C197.601 149.204 196.443 149.535 195.288 149.893C194.279 150.013 193.268 150.128 192.256 150.219C191.71 150.186 191.166 150.133 190.625 150.048C187.031 149.487 183.364 148.59 180.112 147.004C180.037 146.964 179.969 147.072 180.045 147.115C184.961 149.785 190.944 150.642 196.728 150.819C197.612 150.886 198.477 150.974 199.308 151.215C199.922 151.556 200.505 151.944 201.043 152.434C201.819 153.138 202.345 154.037 203.084 154.762C203.131 154.81 203.184 154.859 203.236 154.907C203.503 155.249 203.788 155.58 204.116 155.886C204.501 156.245 204.937 156.578 205.406 156.884C205.86 157.266 206.351 157.589 206.874 157.852C206.009 157.749 205.141 157.598 204.26 157.386C201.948 156.827 199.671 155.824 197.29 155.608C197.259 155.605 197.259 155.654 197.29 155.655C198.788 155.781 200.251 156.395 201.663 156.871C202.841 157.266 204.044 157.621 205.257 157.903C206.356 158.157 207.514 158.381 208.678 158.469C210.337 158.831 212.264 158.917 213.882 158.695C216.851 158.289 219.605 156.652 222.303 158.834C225.204 161.183 225.905 166.274 223.936 169.274C223.677 169.479 223.395 169.666 223.1 169.833C221.519 170.699 220.053 170.411 218.349 170.301C218.106 170.285 217.873 170.283 217.648 170.291C215.811 170.107 213.966 169.872 212.267 169.276C211.778 169.009 211.262 168.779 210.739 168.576C209.88 167.983 208.881 167.512 207.894 167.119C206.276 166.28 204.642 165.467 202.959 164.765C202.807 164.7 202.672 164.904 202.826 164.983C204.158 165.677 205.505 166.415 206.872 167.135C208.816 168.8 211.754 169.304 212.136 172.284C212.156 172.448 212.162 172.602 212.165 172.757C211.652 173.992 210.92 175.113 209.765 175.984C208.936 176.441 208.174 176.737 206.989 176.637C205.915 176.548 204.865 176.244 203.876 175.803C203.446 175.547 203.022 175.24 202.588 174.873C201.08 173.591 199.835 172.103 198.142 171.027C195.029 169.046 190.821 168.279 187.073 168.653C187.042 168.648 187.013 168.646 186.981 168.641C184.452 168.243 182.303 166.962 180.171 165.659C176.085 163.158 172.348 160.19 168.759 157.081C167.965 156.159 167.233 155.194 166.598 154.169C166.498 154.009 166.268 154.148 166.344 154.309C167.164 156.062 168.476 157.589 169.959 158.998C169.964 159.021 169.974 159.046 169.996 159.07C171.041 160.396 172.251 161.578 173.275 162.925C173.978 163.849 174.608 164.731 175.497 165.504C177.582 167.32 180.615 168.775 180.928 171.408C180.9 171.607 180.848 171.814 180.761 172.034C180.523 172.632 179.995 173.147 179.718 173.741C179.099 175.078 179.002 176.527 179.216 177.963C179.326 178.698 179.524 179.423 179.786 180.132C179.833 180.446 179.901 180.757 179.982 181.07C179.606 180.359 179.19 179.679 178.701 179.077C177.936 178.132 177.013 177.27 176.031 176.457C175.158 175.584 174.188 174.808 173.077 174.191C172.787 173.979 172.499 173.766 172.217 173.556C172.164 173.517 172.094 173.579 172.141 173.63C173.84 175.42 175.816 176.991 177.46 178.818C179.075 180.615 179.822 183.005 180.764 185.174C182.334 188.8 183.89 193.318 182.991 197.316C182.402 198.321 181.511 199.113 180.189 199.46C180.089 199.482 180.003 199.499 179.906 199.518C179.501 199.543 179.06 199.494 178.576 199.342C176.699 198.746 175.111 197.085 174.669 195.256C174.059 192.762 173.945 190.655 172.598 188.526C171.948 187.267 171.088 186.091 170.202 184.984C170.108 184.869 170.014 184.753 169.919 184.638C169.48 183.849 169.034 183.065 168.602 182.285C167.308 179.934 165.832 178.689 163.835 176.905C162.53 175.739 161.352 174.466 160.257 173.122C159.099 171.378 157.933 169.662 156.619 168.02C155.74 166.647 154.899 165.255 154.071 163.871C154.057 163.726 153.95 163.581 153.821 163.456C153.652 163.174 153.483 162.89 153.315 162.608C153.26 162.521 153.101 162.58 153.139 162.679C154.002 164.876 155.286 166.816 156.636 168.742C158.208 171.6 160.066 174.325 161.89 177.041C162.672 178.203 163.649 179.136 164.472 180.231C166.033 182.306 165.306 182.88 164.046 183.252C162.269 183.008 160.429 183.13 158.647 183.68C157.405 184.065 156.326 184.626 155.359 185.306C153.297 182.832 151.841 179.98 149.81 177.488C149.731 177.39 149.574 177.515 149.638 177.614C151.32 180.332 152.779 183.225 154.703 185.797C154.267 186.146 153.853 186.516 153.461 186.909L153.396 186.964C152.22 187.953 151.072 188.985 150.115 190.177C148.84 191.766 148.116 193.563 146.412 194.716C146.337 194.743 146.263 194.768 146.185 194.789C145.442 194.981 144.744 194.972 144.062 194.799C143.728 194.648 143.407 194.45 143.108 194.173C142.46 193.57 142.008 192.817 141.525 192.087C140.879 190.616 140.121 189.182 139.389 187.722C137.578 184.114 136.635 180.192 134.734 176.632C134.711 176.589 134.646 176.626 134.666 176.669C136.161 179.885 136.966 183.342 138.404 186.576C139.355 188.715 140.429 190.773 141.198 192.935C141.334 193.761 141.498 194.589 141.323 195.424C141.224 195.898 141.033 196.259 140.783 196.552C140.188 196.579 139.595 196.552 139.021 196.436C137.042 196.046 135.656 194.644 134.379 193.242C133.602 192.387 133.033 191.53 132.56 190.622C132.262 189.537 131.992 188.428 131.587 187.355C129.852 182.735 126.65 178.637 122.251 176.078C119.883 174.702 116.99 173.681 114.083 173.413C113.83 173.208 113.597 172.978 113.404 172.701C112.656 171.63 112.798 170.223 113.001 168.874C113.705 166.338 114.217 163.77 114.219 161.098C114.219 156.4 113.903 151.422 112.672 146.86C112.654 146.794 112.542 146.805 112.547 146.877C112.816 150.533 113.202 154.132 113.307 157.776C113.208 157.741 113.083 157.767 113.061 157.887C112.973 158.375 112.941 158.867 112.923 159.358C112.905 159.37 112.892 159.386 112.887 159.411C112.103 163.421 110.642 167.068 108.524 170.605C107.476 172.353 106.292 174.023 105.123 175.702C100.834 179.069 98.093 186.423 95.9398 190.292C95.3987 191.272 94.7524 192.309 93.9816 193.194C92.7615 194.256 91.5629 195.209 89.5598 194.858C87.4555 194.491 86.0936 192.856 84.7408 191.398C83.4564 190.008 82.1302 188.858 80.5732 188.202C80.3312 188.055 80.0944 187.916 79.8943 187.777C79.3143 187.377 79.1908 187.209 79.1581 186.502C79.151 186.333 79.153 186.165 79.1592 185.994C79.5604 184.983 80.0954 184.024 80.7815 183.123C81.734 181.874 83.0593 180.938 83.9271 179.651C84.5427 179.074 85.1328 178.478 85.6586 177.827C87.3933 175.672 89.0023 173.413 90.6236 171.179C90.6553 171.136 90.5828 171.083 90.5491 171.124C88.6868 173.332 86.9461 175.651 85.0348 177.818C83.8893 179.115 82.5171 180.259 81.1705 181.409C80.759 181.724 80.3619 182.058 79.9933 182.435C79.786 182.62 79.5808 182.806 79.3797 182.994C77.2479 184.994 74.9865 186.807 72.6188 188.544C71.3294 189.488 69.8857 190.399 68.7923 191.572C67.7315 192.404 66.686 193.256 65.5956 194.011C63.6006 195.393 60.7266 196.983 58.1579 196.342C55.5125 195.677 55.5983 193.773 56.0996 191.887C56.1404 191.81 56.1772 191.731 56.218 191.657C57.9353 189.256 58.5254 186.137 58.2773 183.1C58.9369 181.532 59.7199 180.021 60.7593 178.554C61.1054 178.243 61.4127 177.938 61.6557 177.684L61.6639 177.665C64.7411 174.866 68.0643 172.276 71.2416 169.629L71.217 169.607C67.5263 172.461 63.6333 175.189 60.0589 178.215C59.7832 178.372 59.5096 178.532 59.234 178.693C58.652 179.035 58.1109 179.215 57.5392 179.365C57.2288 178.4 56.8357 177.481 56.3681 176.644C55.0337 174.254 52.9958 172.334 50.6007 170.972C50.569 170.911 50.5333 170.852 50.5037 170.79C49.7134 169.124 50.9131 168.433 51.7431 167.223L51.7625 167.163C53.0234 166.11 54.415 165.179 55.8117 164.188C55.8546 164.155 55.8178 164.091 55.7678 164.117C55.6718 164.163 55.5748 164.209 55.4788 164.255C56.8143 163.398 58.0629 162.444 59.0175 161.107C59.0859 161.009 58.9246 160.889 58.8501 160.982C56.9072 163.389 53.5339 164.137 50.9988 165.805C49.4204 166.841 48.0339 167.872 46.1972 168.473C45.6867 168.639 45.165 168.766 44.6403 168.877C44.4289 168.844 44.2166 168.81 44.0032 168.784C37.9325 168.066 32.8726 170.997 28.3456 174.561C25.6002 176.718 22.9763 179.324 19.6061 180.571C15.949 181.922 11.4956 180.987 10.5114 176.915C9.75074 173.782 10.4981 170.297 12.0459 167.493C13.0842 165.618 14.5646 164.385 16.0491 163.063C16.6372 162.7 17.2385 162.315 17.8215 161.906C18.1982 161.689 18.5678 161.462 18.9262 161.227C19.5735 160.91 20.2116 160.59 20.8425 160.31C23.6645 159.056 26.0525 158.917 29.0899 159.083C29.1797 159.088 29.1991 158.95 29.1113 158.931C28.22 158.76 27.3308 158.665 26.4436 158.637C25.4175 158.504 24.3506 158.46 23.3092 158.335C22.8671 158.06 22.569 157.693 22.4506 157.155C22.523 156.919 22.5833 156.674 22.6211 156.421C23.0488 153.529 21.7471 150.341 24.9162 148.491C27.6401 146.899 30.9695 147.608 33.8976 148.128C37.9958 148.863 42.5238 148.697 43.8398 144.105C44.2564 142.647 44.1175 141.283 43.7214 139.957V139.952C44.139 140.271 44.5933 140.55 45.0486 140.788C45.5387 141.045 46.0563 141.294 46.5893 141.527C48.1891 142.5 50.0248 143.079 51.8513 142.91C51.8952 142.909 51.9034 142.853 51.8616 142.839C49.1397 141.89 46.671 141.021 44.7342 138.821C43.2242 137.104 41.4058 133.605 41.8397 131.043C42.6831 129.586 44.9506 129.267 46.43 129.514C47.1345 129.632 47.8226 129.854 48.5036 130.103C50.375 130.999 52.4343 131.702 54.2322 132.445C55.3461 132.907 56.461 133.344 57.579 133.769C59.0696 134.663 60.8481 135.231 62.4245 135.472C62.791 135.589 63.1545 135.713 63.5241 135.827C63.6701 135.87 63.7568 135.663 63.6272 135.593C63.571 135.561 63.5139 135.534 63.4567 135.503C63.4679 135.466 63.4648 135.429 63.4332 135.404C62.1151 134.409 60.4397 133.905 58.9838 133.113C58.698 132.958 58.4427 132.783 58.1997 132.6C57.9312 132.21 57.7924 131.755 57.7474 131.277C58.2375 131.088 58.7102 130.84 59.1513 130.512C61.2126 128.974 61.7323 125.842 60.8522 123.581C60.796 123.435 60.6694 123.327 60.5234 123.26C60.5888 121.975 60.3141 120.724 59.5331 119.811C59.3606 119.606 59.0737 119.797 59.0461 120.003C58.8052 122.118 59.0645 124.154 57.8485 126.082C56.6233 128.032 54.173 128.96 51.9095 128.226C51.8228 128.054 51.6686 127.907 51.4225 127.814C49.9105 127.246 49.3091 125.553 47.6786 125.112C46.2442 124.726 44.482 125.235 43.1333 125.715C40.3828 126.699 38.5931 128.849 38.3154 131.683C38.2235 132.593 38.3654 133.498 38.6155 134.395C38.8708 136.699 39.663 139.024 40.5646 140.712C40.5972 140.768 40.6381 140.811 40.6881 140.846C40.7749 141.766 40.6646 142.679 40.2184 143.597C39.2077 145.68 37.3046 146.147 35.1453 145.975C33.8752 145.661 32.6 145.352 31.3289 145.031C28.8377 143.908 26.9203 141.56 23.8186 141.952C20.7404 142.347 18.4545 144.848 17.944 147.708C17.7664 148.715 17.798 149.749 17.9889 150.757C18.0716 151.868 18.4177 152.931 19.0456 153.815C19.7338 155.383 20.2299 156.772 18.7771 158.485C16.5871 161.074 13.0393 162.254 10.4613 164.428C6.00277 168.188 4.65509 176.566 7.8742 181.45C11.3812 186.768 19.0783 186.391 23.7594 182.975C27.2848 180.405 30.5407 177.482 34.1529 175.03C36.7533 173.263 39.222 172.256 42.0133 172.044C42.145 172.165 42.3094 172.248 42.5054 172.26C49.2132 172.755 55.2338 176.669 55.5166 183.645C55.6483 186.86 54.4007 189.387 52.5701 191.976C51.2357 193.861 50.6568 196.508 51.0621 198.773C52.0872 204.497 59.4055 203.409 62.9401 200.689C65.3679 198.822 66.7748 196.053 69.07 194.05C70.2635 193.009 71.7755 191.842 73.2733 191.212C74.1932 190.821 75.1457 190.733 76.1065 190.692C77.9371 191.163 79.7728 191.295 81.2205 192.873C82.56 194.343 83.2522 196.254 84.7051 197.654C87.2319 200.076 91.131 200.829 94.2225 198.956C97.7898 196.801 99.1201 192.597 100.375 188.967C101.114 186.837 101.828 184.687 102.931 182.7C103.555 181.573 104.306 180.545 105.182 179.582C105.312 179.439 105.453 179.272 105.61 179.097C105.79 179.151 105.999 179.123 106.133 178.975C108.242 176.595 111.788 177.032 114.735 177.278C117.701 177.527 120.051 178.083 122.266 180.107C124.253 181.922 126.012 184.031 127.374 186.313C128.001 187.366 128.529 188.521 129.092 189.655C129.196 192.944 131.749 196.533 133.864 198.755C136.378 201.398 140.239 204.047 144.102 202.557C148.855 200.719 150.176 196.4 152.844 192.642C154.413 190.443 156.169 188.119 158.749 186.952C160.429 186.195 162.178 186.283 163.884 186.126C165.988 186.514 167.933 187.227 169.396 188.921C171.112 190.909 171.641 193.683 172.152 196.154C172.614 198.397 172.784 200.474 174.454 202.211C175.845 203.659 177.036 204.275 179.107 204.1C183.333 203.742 185.727 199.303 186.611 195.662C187.327 192.734 186.738 190.258 185.559 187.888C185.559 187.849 185.554 187.805 185.542 187.756C184.721 183.874 181.218 180.448 182.598 176.228C183.163 174.51 185.034 172.642 186.747 171.805C187.181 171.598 187.682 171.466 188.213 171.388C190.335 171.57 192.492 171.514 194.486 172.339C196.885 173.332 198.822 175.397 200.755 177.032C203.411 179.272 206.43 181.419 210.079 179.906C211.785 179.197 213.157 177.907 214.227 176.474C214.993 175.441 215.611 174.103 216.733 173.39C218.126 172.506 219.341 172.794 220.808 173.307C223.424 174.222 225.413 174.185 227.002 172.787C227.107 173.18 227.567 173.224 227.859 173.005C230.374 171.11 231.239 166.098 229.822 163.073Z",
    fill: "url(#paint0_linear_412_8854)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M171.352 137.712C172.444 139.589 173.905 141.895 175.962 142.894C176.049 142.936 175.986 143.054 175.9 143.038C174.768 142.807 174.036 141.781 173.359 140.959C172.539 139.959 171.742 138.945 171.256 137.751C171.232 137.697 171.323 137.663 171.352 137.712Z",
    fill: "#FF5F3D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M176.25 143.034C176.796 143.188 177.321 143.394 177.871 143.535C178.422 143.676 178.983 143.733 179.541 143.844C179.585 143.853 179.575 143.921 179.531 143.918C178.445 143.886 177.183 143.588 176.216 143.11C176.172 143.089 176.203 143.018 176.25 143.034Z",
    fill: "#FF5F3D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M180.054 143.913C182.178 143.953 184.13 144.154 186.221 143.608C186.276 143.594 186.3 143.676 186.245 143.692C184.269 144.259 182.073 144.222 180.047 143.954C180.022 143.953 180.027 143.911 180.054 143.913Z",
    fill: "#FF5F3D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M187.327 143.046C187.575 142.792 187.956 142.53 188.335 142.552C188.385 142.554 188.392 142.619 188.345 142.635C187.983 142.764 187.674 142.829 187.384 143.099C187.347 143.131 187.293 143.081 187.327 143.046Z",
    fill: "#FF5F3D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M189.039 142.016C190.058 141.787 190.756 140.88 191.673 140.425C192.758 139.889 193.545 139.307 194.138 138.256C194.151 138.232 194.198 138.249 194.188 138.277C193.793 139.214 193.116 139.836 192.186 140.286C191.132 140.801 190.231 141.833 189.059 142.088C189.013 142.099 188.992 142.027 189.039 142.016Z",
    fill: "#FF5F3D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M194.417 137.787C194.679 137.539 194.903 137.262 195.149 136.997C195.171 136.976 195.204 137.003 195.191 137.03C195.013 137.35 194.742 137.602 194.441 137.817L194.417 137.787Z",
    fill: "#FF5F3D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M183.6 151.235C184.787 151.669 186.039 152.006 187.163 152.578C187.241 152.618 187.188 152.747 187.103 152.717C185.903 152.301 184.784 151.701 183.593 151.262L183.6 151.235Z",
    fill: "#FF5F3D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M192.165 153.822C192.819 153.863 193.61 153.924 194.17 154.275C194.214 154.303 194.183 154.358 194.136 154.353C193.469 154.266 192.839 154.007 192.165 153.924C192.1 153.917 192.094 153.817 192.165 153.822Z",
    fill: "#FF5F3D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M194.511 154.489C195.014 154.664 195.575 154.759 196.059 154.976C196.08 154.988 196.069 155.027 196.044 155.025C195.521 154.958 194.992 154.694 194.509 154.498L194.511 154.489Z",
    fill: "#FF5F3D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M156.826 154.104C157.929 157 160.574 159.118 162.02 161.873C162.058 161.947 161.951 162.008 161.901 161.938C160.867 160.44 159.865 158.943 158.703 157.529C157.803 156.434 157.26 155.429 156.808 154.11L156.826 154.104Z",
    fill: "#FF5F3D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M163.378 163.903C164.284 165.114 165.306 166.236 166.281 167.395C166.307 167.425 166.266 167.469 166.231 167.44C165.11 166.393 164.199 165.173 163.338 163.924C163.323 163.901 163.361 163.88 163.378 163.903Z",
    fill: "#FF5F3D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M166.402 167.606C167.219 168.503 168.142 169.359 168.892 170.307C168.918 170.339 168.866 170.373 168.838 170.348C167.928 169.553 167.146 168.554 166.367 167.639C166.347 167.616 166.38 167.584 166.402 167.606Z",
    fill: "#FF5F3D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M170.636 171.739C170.829 171.895 171.041 172.049 171.206 172.232C171.245 172.275 171.193 172.357 171.137 172.317C170.926 172.176 170.74 171.989 170.554 171.818C170.502 171.767 170.581 171.696 170.636 171.739Z",
    fill: "#FF5F3D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M127.013 153.335C127.505 155.165 128.03 156.98 128.592 158.788C128.618 158.87 128.49 158.902 128.462 158.824C127.803 157.04 127.286 155.223 126.912 153.363C126.899 153.301 126.998 153.273 127.013 153.335Z",
    fill: "#FF5F3D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M129.901 162.525C129.904 162.457 130.017 162.454 130.014 162.525C130.006 163.177 130.202 163.721 130.38 164.339C130.393 164.38 130.333 164.404 130.307 164.367C129.948 163.842 129.878 163.14 129.901 162.525Z",
    fill: "#FF5F3D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M131.05 166C131.379 167.288 131.867 168.521 132.226 169.801C132.249 169.885 132.118 169.944 132.077 169.861C131.483 168.672 131.165 167.328 130.867 166.047C130.838 165.932 131.021 165.881 131.05 166Z",
    fill: "#FF5F3D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M132.539 170.599C132.722 171.114 132.892 171.627 133.056 172.147C133.221 172.666 133.504 173.145 133.629 173.676C133.642 173.731 133.561 173.768 133.53 173.718C133.269 173.266 133.169 172.766 132.989 172.285C132.78 171.733 132.591 171.195 132.443 170.625C132.427 170.564 132.518 170.542 132.539 170.599Z",
    fill: "#FF5F3D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4153 157.405C99.4868 157.281 99.5695 157.163 99.6481 157.043C99.6695 157.01 99.7236 157.038 99.7032 157.072C99.6297 157.197 99.5623 157.322 99.4806 157.44C99.4551 157.479 99.3918 157.444 99.4153 157.405Z",
    fill: "#FF5F3D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7888 168.868C92.7638 167.136 93.8093 165.411 94.8578 163.716C95.8849 162.05 97.398 160.718 98.2862 158.974C98.3393 158.87 98.5241 158.944 98.4823 159.052C97.8217 160.796 96.3944 162.101 95.3152 163.614C94.0839 165.337 93.0834 167.18 91.9266 168.947C91.8715 169.03 91.7398 168.956 91.7888 168.868Z",
    fill: "#FF5F3D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5508 152.497C68.532 151.393 69.8766 150.547 70.9313 149.49C71.8808 148.538 72.5801 147.413 73.6368 146.554C73.7348 146.476 73.8706 146.6 73.7798 146.693C71.794 148.709 70.5147 151.488 67.7193 152.705C67.5764 152.767 67.4457 152.614 67.5508 152.497Z",
    fill: "#FF5F3D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1125 154.128L66.1443 154.161L66.0684 154.233L66.0356 154.203L66.1125 154.128Z",
    fill: "#FF5F3D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9021 160.298C60.5208 159.173 61.6214 158.36 62.6362 157.581C63.8154 156.677 64.669 155.577 65.7093 154.545C65.7532 154.5 65.8176 154.565 65.7777 154.61C64.8436 155.658 64.0523 156.723 63.016 157.692C62.0369 158.607 61.0711 159.518 60.1277 160.464C60.0123 160.582 59.8265 160.434 59.9021 160.298Z",
    fill: "#FF5F3D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8271 158C49.4102 157.329 52.0054 156.988 54.4976 155.992C54.5252 155.98 54.5456 156.027 54.5181 156.038C52.1004 157.048 49.5214 158.09 46.8465 158.14C46.7618 158.143 46.7454 158.02 46.8271 158Z",
    fill: "#FF5F3D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6476 158.112C45.0018 158.107 45.3561 158.106 45.7104 158.1C45.7788 158.1 45.7788 158.205 45.7104 158.205C45.3561 158.201 45.0018 158.198 44.6476 158.194C44.5924 158.194 44.5924 158.112 44.6476 158.112Z",
    fill: "#FF5F3D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4135 159.004C36.3743 158.793 39.4055 158.367 42.3745 158.399C42.4643 158.399 42.4848 158.528 42.3959 158.549C39.5505 159.274 36.3334 159.279 33.4135 159.177C33.2961 159.172 33.2981 159.011 33.4135 159.004Z",
    fill: "#FF5F3D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9735 159.019C30.3594 158.961 30.7637 159.016 31.1537 159.023C31.2783 159.023 31.4029 159.025 31.5274 159.028C31.8 158.984 32.0706 158.986 32.3513 158.988C32.3983 158.988 32.4259 159.014 32.4432 159.044H32.5035C32.578 159.046 32.579 159.157 32.5035 159.157L32.4432 159.16C32.4259 159.189 32.3983 159.213 32.3513 159.215C32.0706 159.217 31.799 159.219 31.5274 159.173C31.4029 159.176 31.2783 159.178 31.1537 159.18C30.7627 159.188 30.3604 159.243 29.9735 159.185C29.8877 159.173 29.8877 159.031 29.9735 159.019Z",
    fill: "#FF5F3D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7056 148.968C39.5387 148.761 40.4127 148.786 41.2693 148.782C42.1105 148.774 43.0335 148.7 43.8421 148.939C43.9483 148.971 43.9483 149.114 43.8421 149.146C43.0335 149.384 42.1105 149.308 41.2693 149.303C40.4127 149.299 39.5387 149.324 38.7056 149.116C38.6291 149.098 38.6291 148.987 38.7056 148.968Z",
    fill: "#FF5F3D"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0168 148.417C47.2318 148.313 48.4386 148.332 49.6453 148.131C50.6418 147.965 51.5964 147.693 52.6164 147.703C52.7246 147.706 52.7715 147.851 52.6725 147.905C51.0716 148.766 47.6361 149.588 46.0005 148.475C45.9739 148.457 45.9842 148.42 46.0168 148.417Z",
    fill: "#FF5F3D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5428 153.071C85.7378 152.708 86.0063 152.391 86.1952 152.022C86.4014 151.624 86.5628 151.195 86.6924 150.767C86.7271 150.652 86.8956 150.703 86.8772 150.819C86.7465 151.639 86.3872 152.636 85.7103 153.195C85.6194 153.271 85.4856 153.177 85.5428 153.071Z",
    fill: "#FF5F3D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9931 161.556C79.8149 160.124 80.8226 158.766 81.9273 157.523C82.4592 156.925 83.1361 156.502 83.6691 155.913C84.1438 155.392 84.4603 154.804 84.9759 154.31C85.0841 154.209 85.2383 154.361 85.1413 154.472C84.688 154.982 84.3736 155.592 83.9223 156.103C83.4424 156.646 82.788 156.981 82.2581 157.475C81.0003 158.651 80.1314 160.256 79.1962 161.669C79.1146 161.791 78.9195 161.683 78.9931 161.556Z",
    fill: "#FF5F3D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8468 164.886C76.4094 164.043 77.1945 163.329 78.0072 162.713C78.0776 162.657 78.1787 162.752 78.1083 162.808C77.3038 163.459 76.6299 164.2 75.9357 164.953C75.8928 164.999 75.8121 164.94 75.8468 164.886Z",
    fill: "#FF5F3D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7677 145.772C89.5753 144.201 89.3701 142.308 90.242 140.784C90.2604 140.751 90.3196 140.772 90.3063 140.811C89.7295 142.472 89.8581 144.329 88.9393 145.867C88.8749 145.975 88.7106 145.88 88.7677 145.772Z",
    fill: "#FF5F3D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M168.205 122.568C168.224 122.521 168.302 122.539 168.286 122.589C167.821 124.201 167.627 125.844 167.238 127.468C167.22 127.546 167.091 127.528 167.091 127.447C167.076 125.8 167.62 124.098 168.205 122.568Z",
    fill: "#FF5F3D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M166.712 130.29C166.718 130.217 166.83 130.217 166.833 130.29C166.856 131.184 166.87 132.082 166.752 132.969C166.744 133.03 166.658 133.032 166.652 132.969C166.58 132.078 166.642 131.179 166.712 130.29Z",
    fill: "#FF5F3D"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M166.864 136.069C167.394 139.316 167.698 142.446 169.507 145.317C169.535 145.363 169.465 145.403 169.433 145.359C167.394 142.526 167.27 139.455 166.699 136.112C166.682 136.009 166.846 135.964 166.864 136.069Z",
    fill: "#FF5F3D"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1752 119.464C71.1671 119.441 71.2038 119.427 71.214 119.448C72.6189 122.363 72.9334 126.257 72.7404 129.433C72.7332 129.551 72.5433 129.553 72.5484 129.433C72.6924 126.247 72.3044 122.485 71.1752 119.464Z",
    fill: "#FF5F3D"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4824 147.038C68.3024 143.564 70.1738 140.24 71.6654 136.066C71.693 135.985 71.8145 136.018 71.7951 136.101C70.8691 140.127 68.5811 144.176 65.5682 147.119C65.5121 147.174 65.4365 147.093 65.4824 147.038Z",
    fill: "#FF5F3D"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M144.62 136.283C144.625 136.223 144.724 136.221 144.719 136.283C144.578 138.306 144.667 140.311 144.701 142.332C144.704 142.392 144.599 142.41 144.588 142.348C144.282 140.339 144.387 138.293 144.62 136.283Z",
    fill: "#FF5F3D"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M144.977 145.175C144.957 146.357 145.644 147.264 145.903 148.38C146.177 149.572 146.269 150.69 146.875 151.794C146.927 151.894 146.788 151.965 146.721 151.879C145.929 150.875 145.919 149.634 145.676 148.441C145.446 147.332 144.813 146.313 144.85 145.175C144.852 145.096 144.977 145.093 144.977 145.175Z",
    fill: "#FF5F3D"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M136.233 150.613C137.354 154.174 138.807 157.76 140.532 161.09C140.6 161.224 140.407 161.332 140.323 161.208C138.208 158.053 137.183 154.202 136.128 150.641C136.109 150.576 136.211 150.551 136.233 150.613Z",
    fill: "#FF5F3D"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M142.722 165.176C142.606 164.998 142.484 164.823 142.372 164.636C142.516 164.793 142.63 164.979 142.722 165.176Z",
    fill: "#FF5F3D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M143.104 166.188C142.987 165.871 142.879 165.509 142.722 165.177C142.923 165.482 143.101 165.791 143.171 166.17C143.183 166.213 143.119 166.23 143.104 166.188Z",
    fill: "#FF5F3D"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M142.28 164.483C142.31 164.537 142.34 164.585 142.372 164.637C142.33 164.593 142.291 164.548 142.244 164.511C142.221 164.49 142.265 164.455 142.28 164.483Z",
    fill: "#FF5F3D"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M143.866 167.432C144.387 168.234 144.917 169.038 145.21 169.943C145.233 170.016 145.126 170.056 145.087 169.994C144.57 169.202 144.188 168.336 143.712 167.52C143.658 167.423 143.806 167.339 143.866 167.432Z",
    fill: "#FF5F3D"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M146.086 171.477C146.331 171.835 146.648 172.159 146.815 172.563C146.842 172.625 146.74 172.68 146.695 172.63C146.408 172.295 146.264 171.874 146.055 171.493L146.086 171.477Z",
    fill: "#FF5F3D"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M148.793 175.623C148.872 175.829 149.003 176.027 149.138 176.203C149.17 176.242 149.107 176.302 149.065 176.272C148.835 176.113 148.713 175.926 148.629 175.667C148.597 175.565 148.757 175.526 148.793 175.623Z",
    fill: "#FF5F3D"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8527 141.927C58.5031 141.716 59.2024 141.361 59.7252 140.924C59.8201 140.846 59.9365 140.964 59.861 141.054C59.4434 141.564 59.0554 141.908 58.4265 142.176C58.2019 142.271 57.9681 142.341 57.7384 142.424C57.4821 142.518 57.2544 142.661 56.9808 142.689C56.9155 142.696 56.8767 142.627 56.8879 142.573C56.9829 142.169 57.4893 142.045 57.8527 141.927Z",
    fill: "#FF5F3D"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5415 142.786C53.6391 142.72 54.7111 142.811 55.8055 142.83V142.864C54.7111 142.884 53.6391 142.972 52.5415 142.909C52.4588 142.904 52.4588 142.79 52.5415 142.786Z",
    fill: "#FF5F3D"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M103.532 139.476C103.535 139.404 103.642 139.404 103.644 139.476C103.885 143.102 103.294 146.31 101.797 149.639C101.784 149.666 101.737 149.648 101.744 149.618C102.831 146.377 103.443 142.877 103.532 139.476Z",
    fill: "#FF5F3D"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3144 156.554C99.7218 155.965 99.879 155.43 100.087 154.762C100.33 153.997 100.744 153.43 100.817 152.595C100.824 152.5 100.979 152.499 100.971 152.595C100.911 153.552 100.488 154.286 100.273 155.204C100.14 155.769 100.007 156.418 99.3951 156.656C99.3379 156.677 99.2828 156.603 99.3144 156.554Z",
    fill: "#FF5F3D"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M174.985 143.825C175.617 144.038 175.991 144.504 176.498 144.899C177.217 145.461 178.015 145.98 178.829 146.4C178.879 146.428 178.838 146.493 178.787 146.472C178.077 146.174 177.363 145.96 176.741 145.502C176.091 145.026 175.681 144.285 174.946 143.912C174.897 143.887 174.93 143.807 174.985 143.825Z",
    fill: "#FF5F3D"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1292 152.56C61.1654 153.5 60.0465 154.292 58.8897 155.003C57.8218 155.66 56.614 156.087 55.5603 156.752C55.5021 156.789 55.5368 156.886 55.6093 156.866C58.0831 156.14 60.6774 154.636 62.213 152.622C62.2497 152.574 62.1711 152.519 62.1292 152.56Z",
    fill: "#FFF8E8"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0582 158.294C49.2317 158.95 47.2735 159.606 45.3408 159.834C44.1401 159.976 42.9344 160.019 41.8093 160.477C41.7511 160.5 41.7939 160.581 41.8501 160.57C43.3213 160.274 44.8129 160.17 46.2842 159.883C48.0351 159.544 49.4298 158.994 51.0725 158.345C51.1031 158.331 51.0909 158.283 51.0582 158.294Z",
    fill: "#FFF8E8"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3478 160.51C36.2348 160.546 31.1871 160.272 26.0792 160.163C21.7085 160.069 18.7313 161.812 15.9043 164.893C15.7583 165.05 15.9798 165.263 16.1452 165.124C17.8186 163.729 19.5573 162.267 21.6799 161.533C23.879 160.771 26.3028 160.861 28.602 160.948C32.8309 161.108 37.1343 161.085 41.3478 160.634C41.4274 160.625 41.4325 160.51 41.3478 160.51Z",
    fill: "#FFF8E8"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6134 135.76C58.4566 134.945 57.0201 134.046 55.5367 133.97C55.3713 133.963 55.3294 134.181 55.456 134.256C56.6751 135.003 58.229 135.354 59.5603 135.882C59.6379 135.913 59.6716 135.802 59.6134 135.76Z",
    fill: "#FFF8E8"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1978 133.657C54.0191 133.518 53.8272 133.398 53.6107 133.324C53.577 133.313 53.5535 133.363 53.5862 133.38C53.7843 133.476 53.9711 133.571 54.1447 133.707C54.1825 133.735 54.2355 133.685 54.1978 133.657Z",
    fill: "#FFF8E8"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0409 132.617C51.3017 131.858 50.342 131.821 49.3323 131.55C48.0714 131.211 46.8738 130.781 45.5394 130.899C44.205 131.014 42.9941 131.772 43.2136 133.17C43.2647 133.493 43.8374 133.419 43.8109 133.093C43.5506 129.822 50.3543 131.98 51.9827 132.689C52.0307 132.709 52.0807 132.656 52.0409 132.617Z",
    fill: "#FFF8E8"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3118 149.819C45.7145 150.231 42.8323 150.228 40.1972 150.247C37.6591 150.263 35.2179 149.372 32.6921 149.138C30.499 148.935 23.9781 147.394 23.583 150.845C23.5493 151.138 24.0261 151.247 24.1598 150.995C25.338 148.75 29.231 149.203 31.4587 149.32C33.759 149.44 36.0102 149.954 38.2839 150.26C41.4693 150.693 45.2071 150.727 48.3169 149.84L48.3118 149.819Z",
    fill: "#FFF8E8"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3756 152.667C24.3664 152.644 24.3583 152.621 24.3491 152.6C24.2327 152.302 23.8988 152.129 23.5885 152.302L23.5282 152.334C23.129 152.556 23.1678 153.152 23.5977 153.319C23.9969 153.473 24.5502 153.113 24.3756 152.667Z",
    fill: "#FFF8E8"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9911 167.178C14.0493 167.086 13.9095 166.975 13.8319 167.061C11.6072 169.53 9.85213 173.93 12.1952 176.877C12.2146 176.903 12.2688 176.898 12.2647 176.858C12.1228 175.397 11.6827 174.038 11.8144 172.547C11.9972 170.481 12.9028 168.922 13.9911 167.178Z",
    fill: "#FFF8E8"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0788 162.274C93.2866 163.081 92.6648 164.021 92.0736 164.97C91.8511 165.329 91.6908 165.716 91.4703 166.075C91.1997 166.51 90.8873 166.76 90.7198 167.243C90.6382 167.481 90.9761 167.576 91.1099 167.403C92.286 165.871 93.4989 164.137 94.2116 162.351C94.2432 162.277 94.1309 162.221 94.0788 162.274Z",
    fill: "#FFF8E8"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7282 168.956C88.9451 170.962 87.4903 172.631 86.3468 174.442C86.3008 174.516 86.4121 174.602 86.4724 174.535C87.2493 173.67 87.8333 172.675 88.5092 171.742C89.1218 170.894 89.6547 170.007 90.0161 169.033C90.0815 168.857 89.7946 168.786 89.7282 168.956Z",
    fill: "#FFF8E8"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9593 174.866C82.1521 178.536 78.3061 182.133 74.1773 185.449C69.8954 188.889 65.4879 191.688 60.5587 194.152C60.3279 194.27 60.4903 194.603 60.7312 194.547C65.6308 193.423 69.9781 189.783 73.6587 186.646C78.0111 182.935 82.1358 179.116 86.1635 175.063C86.2911 174.934 86.091 174.741 85.9593 174.866Z",
    fill: "#FFF8E8"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5796 194.505C59.55 194.505 59.55 194.551 59.5796 194.551C59.6102 194.551 59.6102 194.505 59.5796 194.505Z",
    fill: "#FFF8E8"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M126.306 176.335C125.187 175.466 124.304 174.254 122.947 173.722C120.974 172.949 118.564 172.533 116.439 172.699C116.369 172.704 116.319 172.808 116.398 172.843C117.947 173.522 119.568 173.79 121.181 174.284C123.026 174.848 123.941 175.797 125.412 176.885C127.147 178.169 128.65 179.37 129.915 181.1C130.942 182.502 131.674 184.063 132.618 185.509C132.649 185.558 132.73 185.527 132.715 185.47C131.732 181.811 129.324 178.679 126.306 176.335Z",
    fill: "#FFF8E8"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M114.458 169.378C114.528 168.559 114.64 167.703 114.771 166.889C114.774 166.863 114.737 166.852 114.729 166.877C114.354 167.939 114.139 168.976 114.06 170.099C114.014 170.78 113.886 171.579 114.411 172.113C114.61 172.314 114.886 172.023 114.719 171.815C114.191 171.159 114.39 170.149 114.458 169.378Z",
    fill: "#FFF8E8"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M152.223 186.088C150.809 186.462 149.61 187.896 148.755 188.97C148.266 189.58 147.819 190.217 147.377 190.857C146.877 191.578 146.049 193.372 145.101 193.491C145.012 193.5 144.975 193.624 145.077 193.649C146.415 193.996 147.348 192.007 147.918 191.162C148.574 190.188 149.238 189.215 150.025 188.333C150.72 187.552 151.624 187.035 152.354 186.303C152.443 186.211 152.354 186.054 152.223 186.088Z",
    fill: "#FFF8E8"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M178.738 95.56C178.698 94.7263 177.339 94.7245 177.381 95.56C177.857 104.741 171.921 112.453 170.941 121.339C170.929 121.454 171.119 121.473 171.15 121.365C173.65 112.84 179.151 104.658 178.738 95.56Z",
    fill: "#FFF8E8"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M162.032 180.058C161.209 178.515 159.823 177.277 158.793 175.847C157.756 174.405 156.821 172.89 155.986 171.334C155.142 169.758 154.494 168.086 153.493 166.589C152.562 165.203 151.423 163.954 150.446 162.6C145.986 156.429 144.366 149.329 143.486 141.996C143.478 141.94 143.394 141.935 143.391 141.996C143.183 149.1 145.976 156.124 149.677 162.169C150.678 163.804 151.915 165.284 152.931 166.906C153.951 168.539 154.578 170.363 155.448 172.07C156.865 174.846 158.9 178.663 161.658 180.418C161.899 180.57 162.15 180.274 162.032 180.058Z",
    fill: "#FFF8E8"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M198.135 133.523C196.84 135.649 196.033 138.027 194.154 139.778C192.097 141.693 189.486 143.314 186.77 144.174C186.694 144.197 186.725 144.303 186.801 144.287C192.034 143.099 196.917 138.575 198.239 133.566C198.254 133.508 198.168 133.471 198.135 133.523Z",
    fill: "#FFF8E8"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M198.509 132.247C198.393 132.519 198.347 132.808 198.308 133.101C198.305 133.134 198.365 133.143 198.37 133.109C198.427 132.824 198.516 132.549 198.584 132.268C198.598 132.219 198.527 132.203 198.509 132.247Z",
    fill: "#FFF8E8"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-98-inside-1_412_8854",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.053 171.215C225.962 173.575 223.686 173.507 220.861 172.576C220.06 172.312 219.308 171.941 218.45 171.869C217.262 171.77 216.096 172.016 215.262 172.876C214.47 173.694 214.305 174.82 213.859 175.812C212.586 177.442 210.877 178.683 208.83 179.223C208.649 179.249 208.469 179.277 208.286 179.29C208.144 179.302 208.035 179.352 207.941 179.417C207.559 179.475 207.178 179.523 206.778 179.53C202.833 179.601 200.447 177.084 197.917 174.615C195.545 172.299 193.001 171 190.04 170.959C189.381 170.786 188.714 170.64 188.027 170.5C185.655 170.019 183.979 169.081 181.907 167.974C178.161 165.974 174.776 163.884 172.045 160.618C171.953 160.507 171.757 160.653 171.841 160.768C173.947 163.559 176.666 166.147 179.846 167.774C181.627 168.686 183.361 170.001 185.288 170.63C186.005 170.864 186.747 171.046 187.499 171.218C187.074 171.308 186.647 171.4 186.203 171.539C182.395 172.73 180.547 175.569 181.19 179.369C182.191 185.282 187.722 188.852 185.853 195.365C184.815 198.98 182.15 203.383 177.653 203.332C173.252 203.281 173.179 197.447 172.248 194.368C171.179 190.83 169.222 186.887 165.252 185.7C161.133 184.468 156.093 186.614 153.43 189.638C150.176 193.326 149.191 197.987 145.48 201.103C139.85 204.399 134.06 199.696 131.439 194.959C129.288 191.067 128.132 186.723 125.592 183.02C123.446 179.896 120.551 177.607 116.674 176.865C113.245 176.211 108.692 175.897 105.529 177.617C105.482 177.644 105.445 177.678 105.401 177.703C106.199 176.678 107.019 175.66 107.751 174.571C109.319 172.247 110.49 169.7 111.319 167.053C113.046 161.531 113.135 155.833 112.16 150.176C112.147 150.09 111.996 150.111 112.003 150.197C112.479 156.316 112.215 162.591 109.97 168.393C108.3 172.705 104.743 176.091 102.743 180.147C101.426 181.985 100.689 184.268 100.072 186.379C98.5957 191.439 96.8131 199.542 89.6826 199.336C83.7835 199.167 83.4506 193.329 79.2361 190.942C76.4029 189.339 72.8591 190.174 70.3006 191.862C65.8788 194.781 63.5571 200.966 58.0378 202.343C55.7304 202.921 53.3689 202.272 52.062 200.357C50.7511 198.436 51.1748 196.296 51.9946 194.253C52.4102 193.215 52.9115 192.217 53.4158 191.219C53.4781 191.181 53.5394 191.135 53.5914 191.07C59.8877 183.078 51.3994 171.286 41.8421 171.183C43.2317 170.673 44.6396 170.158 46.0628 169.561C49.9986 167.915 53.3954 164.946 56.6492 162.315C56.7626 162.226 56.6023 162.078 56.49 162.163C54.0641 163.976 51.4974 165.73 48.9103 167.333C46.461 168.848 43.833 169.495 41.0999 170.358C38.3862 171.218 35.4478 172.146 33.2977 173.994C30.3042 175.925 27.6772 178.504 24.9339 180.683C22.0007 183.014 18.5855 185.069 14.6477 185.109C9.89097 185.155 6.88014 181.927 6.11645 177.638C4.85658 170.557 8.43813 163.734 15.1745 160.845C17.0286 160.048 18.7244 159.2 19.2706 157.175C20.1415 153.943 17.6748 150.601 18.2527 147.268C19.434 140.459 25.9079 142.909 30.2705 144.898C32.2849 145.817 34.4156 146.628 36.673 146.166C41.5644 145.168 41.0815 141.32 39.3928 137.859C37.1559 133.273 37.5908 126.746 43.7289 125.318C46.0608 124.776 47.5636 125.718 49.0349 126.753C52.0835 129.67 55.4833 133.343 59.7162 134.26C59.7979 134.278 59.85 134.169 59.7744 134.128C57.2312 132.684 54.8676 131.234 52.7022 129.276C52.3795 128.984 52.0886 128.694 51.8058 128.405C52.2489 128.573 52.7175 128.698 53.2321 128.744C57.6212 129.146 58.9311 125.203 58.9444 121.633C60.0491 124.238 61.0547 126.868 61.7735 129.564C62.288 131.523 62.6495 133.518 62.6464 135.509C62.6515 137.493 62.1614 139.477 61.1303 141.224C59.0495 144.732 55.0392 147.099 50.8032 148.134L50.8318 148.269C53.0207 147.85 55.1219 147.067 57.0321 145.97C58.9311 144.868 60.6361 143.392 61.7867 141.563C62.9486 139.745 63.5499 137.632 63.6184 135.533C63.698 133.43 63.3927 131.35 62.9374 129.322C62.042 125.418 60.5881 121.679 59.0955 117.988C58.8127 117.502 58.5768 116.99 58.3287 116.484C58.0898 116.004 57.8489 115.526 57.6243 115.04C57.4864 114.735 57.3496 114.442 57.2148 114.144C56.8575 113.331 56.5114 112.516 56.1929 111.689C56.0714 111.327 55.955 110.964 55.8559 110.598C55.8018 110.488 55.7406 110.377 55.6854 110.266C53.5159 104.153 52.3969 97.7244 52.3969 91.2897C52.4255 83.3347 54.1499 75.3941 57.4823 68.0742C60.8005 60.7436 65.7134 54.0337 71.8188 48.4353C77.9241 42.836 85.2363 38.3618 93.1958 35.3574C100.694 32.5117 108.781 30.9897 116.897 30.8327C125.014 30.9897 133.101 32.5117 140.599 35.3574C148.559 38.3618 155.871 42.836 161.974 48.4353C168.08 54.0337 172.994 60.7436 176.313 68.0742C179.645 75.3941 181.368 83.3347 181.396 91.2897C181.396 97.7244 180.278 104.153 178.109 110.266C178.053 110.377 177.993 110.488 177.938 110.598C177.839 110.964 177.722 111.327 177.601 111.689C177.283 112.516 176.938 113.331 176.579 114.144C176.443 114.442 176.308 114.735 176.172 115.04C175.947 115.526 175.704 116.004 175.466 116.484C175.218 116.99 174.982 117.502 174.698 117.988C173.205 121.679 171.752 125.418 170.858 129.322C170.4 131.35 170.097 133.43 170.176 135.533C170.244 137.632 170.845 139.745 172.008 141.563C173.158 143.392 174.862 144.868 176.762 145.97C178.673 147.067 180.774 147.85 182.962 148.269L182.991 148.134C178.754 147.099 174.745 144.732 172.664 141.224C171.632 139.477 171.143 137.493 171.149 135.509C171.146 133.518 171.506 131.523 172.022 129.564C172.672 127.118 173.568 124.73 174.554 122.36C173.927 127.543 174.604 133.735 181.399 132.541C183.916 132.098 185.207 130.241 186.402 128.321C186.243 128.774 186.091 129.229 185.95 129.675C184.444 134.428 181.161 139.567 175.252 139.558C175.147 139.556 175.116 139.723 175.225 139.741C178.652 140.278 181.399 138.394 183.668 136.024C184.881 134.763 185.536 133.218 186.104 131.611C187.183 128.552 187.989 126.058 190.46 123.838C194.821 121.547 200.578 124.319 203.178 128.663C206.564 134.313 204.212 139.172 202.473 144.723C201.464 147.943 201.964 151.405 204.438 153.913C206.933 156.436 210.782 157.175 214.162 156.086C216.749 155.25 218.78 154.121 221.621 154.878C224.872 155.744 227.162 158.337 228.472 161.208C229.898 164.327 230.531 168.415 228.053 171.215ZM223.62 154.04C222.134 153.382 220.494 153.059 218.861 153.167C216.235 153.34 214.07 155.059 211.446 155.188C207.236 155.394 203.511 152.123 203.372 148.056C203.273 145.152 205.092 142.586 205.824 139.853C207.836 132.366 203.775 123.108 195.103 121.928C190.641 121.318 188.153 123.589 185.95 126.961C183.981 129.97 180.349 133.465 176.844 129.858C175.897 128.885 175.515 127.587 175.414 126.159C175.477 122.521 176.467 119.073 177.688 115.646C177.769 115.472 177.855 115.302 177.936 115.126C181.339 107.596 183.093 99.4432 183.122 91.2897C183.122 83.1362 181.412 74.9574 178.035 67.4138C174.674 59.8567 169.661 52.9203 163.412 47.1117C157.149 41.3139 149.635 36.6557 141.433 33.5051C133.691 30.5142 125.314 28.8992 116.897 28.7007C108.48 28.8992 100.104 30.5142 92.3616 33.5051C84.1592 36.6557 76.6459 41.3139 70.3823 47.1117C64.1339 52.9203 59.12 59.8567 55.7589 67.4138C52.3826 74.9574 50.6735 83.1362 50.6735 91.2897C50.7021 99.4432 52.4551 107.596 55.859 115.126C55.9029 115.223 55.9519 115.315 55.9958 115.41C56.3766 116.904 56.9862 118.35 57.2496 119.877C57.6161 121.99 57.3537 123.965 56.6768 125.94C56.588 126.053 56.5032 126.166 56.3971 126.277C56.2623 126.42 56.1398 126.55 56.0254 126.679C55.52 127.042 54.9044 127.282 54.0825 127.428C52.0365 127.795 51.3647 126.85 49.7475 125.776C48.0915 124.677 46.5202 124.016 44.4609 124.215C40.1157 124.633 37.2039 128.226 36.966 132.267C36.8241 134.671 37.6541 136.694 38.6802 138.821C39.5909 140.713 39.6746 140.678 38.8558 142.678C38.1115 144.504 38.0033 144.843 36.0267 145.102C33.6489 145.413 31.5069 144.236 29.4578 143.245C25.5771 141.365 20.4029 140.004 17.9178 144.545C16.8846 146.432 16.9111 148.583 17.2869 150.633C17.5972 152.336 18.6019 154.268 18.4426 156.001C18.1465 159.221 15.4001 159.341 13.0121 160.355C8.45855 162.29 5.82956 166.704 4.8382 171.239C3.91831 175.447 4.2389 180.611 7.50701 183.877C10.915 187.284 16.2087 187.072 20.4151 185.291C27.3097 182.371 31.3221 175.179 38.6996 173.095C48.117 170.436 57.564 181.29 52.9809 189.545C52.8737 189.723 52.7655 189.901 52.6552 190.079C52.5827 190.195 52.5174 190.31 52.4388 190.423L52.4265 190.451C50.8103 193.067 49.2094 195.728 49.7424 198.874C50.3172 202.26 53.4117 203.988 56.8289 203.704C61.0864 203.35 63.9195 200.098 66.522 197.198C68.6058 194.876 70.8876 192.259 74.1547 191.56C79.1044 190.499 80.5511 194.571 83.0719 197.502C85.3109 200.103 88.8985 201.288 92.3096 200.306C96.0157 199.237 98.3159 195.858 99.6279 192.555C102.148 186.215 102.181 177.964 111.235 177.81C114.824 177.747 118.584 178.195 121.431 180.479C123.657 182.265 125.15 184.801 126.353 187.296C128.705 192.176 130.186 198.107 134.956 201.445C138.389 203.847 143.005 204.573 146.543 202.029C146.658 201.946 146.723 201.844 146.77 201.739C148.534 200.494 149.81 198.611 150.861 196.705C153.459 191.998 155.795 187.268 162.043 186.681C169.52 185.975 170.657 194.121 172.121 199.29C172.96 202.248 174.089 204.718 177.653 204.715C184.666 204.711 189.06 195.696 187.596 189.878C186.522 185.617 182.157 182.087 182.518 177.488C182.839 173.391 187.977 171.758 191.658 172.428C194.543 172.955 196.279 175.051 198.229 176.971C200.9 179.601 204.075 181.385 208.045 180.865C208.709 180.78 209.332 180.609 209.932 180.403C212.539 179.937 213.924 178.283 215.516 175.996C216.825 174.109 218.547 173.435 220.782 174.231C221.723 174.569 222.63 174.918 223.647 174.931C225.338 174.955 226.953 174.287 228.239 173.269C234.69 168.159 230.28 156.982 223.62 154.04Z"
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M228.053 171.215C225.962 173.575 223.686 173.507 220.861 172.576C220.06 172.312 219.308 171.941 218.45 171.869C217.262 171.77 216.096 172.016 215.262 172.876C214.47 173.694 214.305 174.82 213.859 175.812C212.586 177.442 210.877 178.683 208.83 179.223C208.649 179.249 208.469 179.277 208.286 179.29C208.144 179.302 208.035 179.352 207.941 179.417C207.559 179.475 207.178 179.523 206.778 179.53C202.833 179.601 200.447 177.084 197.917 174.615C195.545 172.299 193.001 171 190.04 170.959C189.381 170.786 188.714 170.64 188.027 170.5C185.655 170.019 183.979 169.081 181.907 167.974C178.161 165.974 174.776 163.884 172.045 160.618C171.953 160.507 171.757 160.653 171.841 160.768C173.947 163.559 176.666 166.147 179.846 167.774C181.627 168.686 183.361 170.001 185.288 170.63C186.005 170.864 186.747 171.046 187.499 171.218C187.074 171.308 186.647 171.4 186.203 171.539C182.395 172.73 180.547 175.569 181.19 179.369C182.191 185.282 187.722 188.852 185.853 195.365C184.815 198.98 182.15 203.383 177.653 203.332C173.252 203.281 173.179 197.447 172.248 194.368C171.179 190.83 169.222 186.887 165.252 185.7C161.133 184.468 156.093 186.614 153.43 189.638C150.176 193.326 149.191 197.987 145.48 201.103C139.85 204.399 134.06 199.696 131.439 194.959C129.288 191.067 128.132 186.723 125.592 183.02C123.446 179.896 120.551 177.607 116.674 176.865C113.245 176.211 108.692 175.897 105.529 177.617C105.482 177.644 105.445 177.678 105.401 177.703C106.199 176.678 107.019 175.66 107.751 174.571C109.319 172.247 110.49 169.7 111.319 167.053C113.046 161.531 113.135 155.833 112.16 150.176C112.147 150.09 111.996 150.111 112.003 150.197C112.479 156.316 112.215 162.591 109.97 168.393C108.3 172.705 104.743 176.091 102.743 180.147C101.426 181.985 100.689 184.268 100.072 186.379C98.5957 191.439 96.8131 199.542 89.6826 199.336C83.7835 199.167 83.4506 193.329 79.2361 190.942C76.4029 189.339 72.8591 190.174 70.3006 191.862C65.8788 194.781 63.5571 200.966 58.0378 202.343C55.7304 202.921 53.3689 202.272 52.062 200.357C50.7511 198.436 51.1748 196.296 51.9946 194.253C52.4102 193.215 52.9115 192.217 53.4158 191.219C53.4781 191.181 53.5394 191.135 53.5914 191.07C59.8877 183.078 51.3994 171.286 41.8421 171.183C43.2317 170.673 44.6396 170.158 46.0628 169.561C49.9986 167.915 53.3954 164.946 56.6492 162.315C56.7626 162.226 56.6023 162.078 56.49 162.163C54.0641 163.976 51.4974 165.73 48.9103 167.333C46.461 168.848 43.833 169.495 41.0999 170.358C38.3862 171.218 35.4478 172.146 33.2977 173.994C30.3042 175.925 27.6772 178.504 24.9339 180.683C22.0007 183.014 18.5855 185.069 14.6477 185.109C9.89097 185.155 6.88014 181.927 6.11645 177.638C4.85658 170.557 8.43813 163.734 15.1745 160.845C17.0286 160.048 18.7244 159.2 19.2706 157.175C20.1415 153.943 17.6748 150.601 18.2527 147.268C19.434 140.459 25.9079 142.909 30.2705 144.898C32.2849 145.817 34.4156 146.628 36.673 146.166C41.5644 145.168 41.0815 141.32 39.3928 137.859C37.1559 133.273 37.5908 126.746 43.7289 125.318C46.0608 124.776 47.5636 125.718 49.0349 126.753C52.0835 129.67 55.4833 133.343 59.7162 134.26C59.7979 134.278 59.85 134.169 59.7744 134.128C57.2312 132.684 54.8676 131.234 52.7022 129.276C52.3795 128.984 52.0886 128.694 51.8058 128.405C52.2489 128.573 52.7175 128.698 53.2321 128.744C57.6212 129.146 58.9311 125.203 58.9444 121.633C60.0491 124.238 61.0547 126.868 61.7735 129.564C62.288 131.523 62.6495 133.518 62.6464 135.509C62.6515 137.493 62.1614 139.477 61.1303 141.224C59.0495 144.732 55.0392 147.099 50.8032 148.134L50.8318 148.269C53.0207 147.85 55.1219 147.067 57.0321 145.97C58.9311 144.868 60.6361 143.392 61.7867 141.563C62.9486 139.745 63.5499 137.632 63.6184 135.533C63.698 133.43 63.3927 131.35 62.9374 129.322C62.042 125.418 60.5881 121.679 59.0955 117.988C58.8127 117.502 58.5768 116.99 58.3287 116.484C58.0898 116.004 57.8489 115.526 57.6243 115.04C57.4864 114.735 57.3496 114.442 57.2148 114.144C56.8575 113.331 56.5114 112.516 56.1929 111.689C56.0714 111.327 55.955 110.964 55.8559 110.598C55.8018 110.488 55.7406 110.377 55.6854 110.266C53.5159 104.153 52.3969 97.7244 52.3969 91.2897C52.4255 83.3347 54.1499 75.3941 57.4823 68.0742C60.8005 60.7436 65.7134 54.0337 71.8188 48.4353C77.9241 42.836 85.2363 38.3618 93.1958 35.3574C100.694 32.5117 108.781 30.9897 116.897 30.8327C125.014 30.9897 133.101 32.5117 140.599 35.3574C148.559 38.3618 155.871 42.836 161.974 48.4353C168.08 54.0337 172.994 60.7436 176.313 68.0742C179.645 75.3941 181.368 83.3347 181.396 91.2897C181.396 97.7244 180.278 104.153 178.109 110.266C178.053 110.377 177.993 110.488 177.938 110.598C177.839 110.964 177.722 111.327 177.601 111.689C177.283 112.516 176.938 113.331 176.579 114.144C176.443 114.442 176.308 114.735 176.172 115.04C175.947 115.526 175.704 116.004 175.466 116.484C175.218 116.99 174.982 117.502 174.698 117.988C173.205 121.679 171.752 125.418 170.858 129.322C170.4 131.35 170.097 133.43 170.176 135.533C170.244 137.632 170.845 139.745 172.008 141.563C173.158 143.392 174.862 144.868 176.762 145.97C178.673 147.067 180.774 147.85 182.962 148.269L182.991 148.134C178.754 147.099 174.745 144.732 172.664 141.224C171.632 139.477 171.143 137.493 171.149 135.509C171.146 133.518 171.506 131.523 172.022 129.564C172.672 127.118 173.568 124.73 174.554 122.36C173.927 127.543 174.604 133.735 181.399 132.541C183.916 132.098 185.207 130.241 186.402 128.321C186.243 128.774 186.091 129.229 185.95 129.675C184.444 134.428 181.161 139.567 175.252 139.558C175.147 139.556 175.116 139.723 175.225 139.741C178.652 140.278 181.399 138.394 183.668 136.024C184.881 134.763 185.536 133.218 186.104 131.611C187.183 128.552 187.989 126.058 190.46 123.838C194.821 121.547 200.578 124.319 203.178 128.663C206.564 134.313 204.212 139.172 202.473 144.723C201.464 147.943 201.964 151.405 204.438 153.913C206.933 156.436 210.782 157.175 214.162 156.086C216.749 155.25 218.78 154.121 221.621 154.878C224.872 155.744 227.162 158.337 228.472 161.208C229.898 164.327 230.531 168.415 228.053 171.215ZM223.62 154.04C222.134 153.382 220.494 153.059 218.861 153.167C216.235 153.34 214.07 155.059 211.446 155.188C207.236 155.394 203.511 152.123 203.372 148.056C203.273 145.152 205.092 142.586 205.824 139.853C207.836 132.366 203.775 123.108 195.103 121.928C190.641 121.318 188.153 123.589 185.95 126.961C183.981 129.97 180.349 133.465 176.844 129.858C175.897 128.885 175.515 127.587 175.414 126.159C175.477 122.521 176.467 119.073 177.688 115.646C177.769 115.472 177.855 115.302 177.936 115.126C181.339 107.596 183.093 99.4432 183.122 91.2897C183.122 83.1362 181.412 74.9574 178.035 67.4138C174.674 59.8567 169.661 52.9203 163.412 47.1117C157.149 41.3139 149.635 36.6557 141.433 33.5051C133.691 30.5142 125.314 28.8992 116.897 28.7007C108.48 28.8992 100.104 30.5142 92.3616 33.5051C84.1592 36.6557 76.6459 41.3139 70.3823 47.1117C64.1339 52.9203 59.12 59.8567 55.7589 67.4138C52.3826 74.9574 50.6735 83.1362 50.6735 91.2897C50.7021 99.4432 52.4551 107.596 55.859 115.126C55.9029 115.223 55.9519 115.315 55.9958 115.41C56.3766 116.904 56.9862 118.35 57.2496 119.877C57.6161 121.99 57.3537 123.965 56.6768 125.94C56.588 126.053 56.5032 126.166 56.3971 126.277C56.2623 126.42 56.1398 126.55 56.0254 126.679C55.52 127.042 54.9044 127.282 54.0825 127.428C52.0365 127.795 51.3647 126.85 49.7475 125.776C48.0915 124.677 46.5202 124.016 44.4609 124.215C40.1157 124.633 37.2039 128.226 36.966 132.267C36.8241 134.671 37.6541 136.694 38.6802 138.821C39.5909 140.713 39.6746 140.678 38.8558 142.678C38.1115 144.504 38.0033 144.843 36.0267 145.102C33.6489 145.413 31.5069 144.236 29.4578 143.245C25.5771 141.365 20.4029 140.004 17.9178 144.545C16.8846 146.432 16.9111 148.583 17.2869 150.633C17.5972 152.336 18.6019 154.268 18.4426 156.001C18.1465 159.221 15.4001 159.341 13.0121 160.355C8.45855 162.29 5.82956 166.704 4.8382 171.239C3.91831 175.447 4.2389 180.611 7.50701 183.877C10.915 187.284 16.2087 187.072 20.4151 185.291C27.3097 182.371 31.3221 175.179 38.6996 173.095C48.117 170.436 57.564 181.29 52.9809 189.545C52.8737 189.723 52.7655 189.901 52.6552 190.079C52.5827 190.195 52.5174 190.31 52.4388 190.423L52.4265 190.451C50.8103 193.067 49.2094 195.728 49.7424 198.874C50.3172 202.26 53.4117 203.988 56.8289 203.704C61.0864 203.35 63.9195 200.098 66.522 197.198C68.6058 194.876 70.8876 192.259 74.1547 191.56C79.1044 190.499 80.5511 194.571 83.0719 197.502C85.3109 200.103 88.8985 201.288 92.3096 200.306C96.0157 199.237 98.3159 195.858 99.6279 192.555C102.148 186.215 102.181 177.964 111.235 177.81C114.824 177.747 118.584 178.195 121.431 180.479C123.657 182.265 125.15 184.801 126.353 187.296C128.705 192.176 130.186 198.107 134.956 201.445C138.389 203.847 143.005 204.573 146.543 202.029C146.658 201.946 146.723 201.844 146.77 201.739C148.534 200.494 149.81 198.611 150.861 196.705C153.459 191.998 155.795 187.268 162.043 186.681C169.52 185.975 170.657 194.121 172.121 199.29C172.96 202.248 174.089 204.718 177.653 204.715C184.666 204.711 189.06 195.696 187.596 189.878C186.522 185.617 182.157 182.087 182.518 177.488C182.839 173.391 187.977 171.758 191.658 172.428C194.543 172.955 196.279 175.051 198.229 176.971C200.9 179.601 204.075 181.385 208.045 180.865C208.709 180.78 209.332 180.609 209.932 180.403C212.539 179.937 213.924 178.283 215.516 175.996C216.825 174.109 218.547 173.435 220.782 174.231C221.723 174.569 222.63 174.918 223.647 174.931C225.338 174.955 226.953 174.287 228.239 173.269C234.69 168.159 230.28 156.982 223.62 154.04Z",
    fill: "#FFBF08",
    stroke: "#1E1E1E",
    strokeOpacity: 0.7,
    strokeWidth: 2.23645,
    mask: "url(#path-98-inside-1_412_8854)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8149 141.995C73.8067 141.955 73.7996 141.916 73.7925 141.876C73.768 141.743 73.6168 141.597 73.477 141.574C71.8108 141.303 70.4825 142.745 69.8617 144.041C68.851 146.154 68.1261 148.916 67.8433 151.222C67.8392 151.247 67.8841 151.259 67.8964 151.233C68.7683 149.538 70.2415 141.296 73.3422 142.449C73.6414 142.56 73.8609 142.241 73.8149 141.995Z",
    fill: "#FFF8E8"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4671 143.432C75.2721 142.991 75.0863 142.501 74.5779 142.339C74.0174 142.161 73.7897 142.995 74.3359 143.182C74.9618 143.397 74.8689 144.249 75.2834 144.646C75.313 144.677 75.3589 144.679 75.3947 144.661C75.8888 144.411 75.6356 143.811 75.4671 143.432Z",
    fill: "#FFF8E8"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M184.353 153.76C182.929 152.231 180.662 150.392 178.536 151.887C178.067 152.212 178.514 152.97 178.995 152.642C182.743 150.071 187.722 159.507 189.424 161.55L189.435 161.544C188.26 158.599 186.528 156.097 184.353 153.76Z",
    fill: "#FFF8E8"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M164.177 154.523C163.663 153.533 163.438 152.588 163.592 151.467C163.663 150.955 162.693 150.946 162.753 151.467C162.865 152.435 162.766 154.382 164.102 154.618C164.162 154.63 164.206 154.576 164.177 154.523Z",
    fill: "#FFF8E8"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M161.718 13.877C157.38 10.9262 152.712 8.38535 147.843 6.32827C137.919 2.12881 127.379 0 116.519 0C105.66 0 95.1209 2.12881 85.1923 6.32827C80.3249 8.38535 75.6572 10.9262 71.3191 13.877C71.1136 14.0186 70.9915 14.2541 70.9915 14.512V21.5906C70.9915 22.0249 71.29 22.2178 71.418 22.2827C71.5489 22.3467 71.892 22.4689 72.2449 22.1984C85.0217 12.453 100.331 7.30059 116.519 7.30059C132.707 7.30059 148.015 12.453 160.792 22.1984C161.145 22.4689 161.487 22.3467 161.619 22.2827C161.748 22.2178 162.046 22.0249 162.046 21.5906V14.512C162.046 14.2541 161.925 14.0186 161.718 13.877Z",
    fill: "url(#paint1_linear_412_8854)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3721 50.4233C41.5235 59.5231 39.4926 69.1648 39.321 79.0983C39.576 79.0072 39.8368 78.9248 40.1014 78.853C40.5716 56.2475 50.8831 35.2405 68.5098 20.998V19.9946C66.2172 21.819 64.0069 23.7898 61.9208 25.877C54.8296 32.9672 49.2623 41.2236 45.3721 50.4233Z",
    fill: "#FFF8E8"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6331 115.061H51.8555C55.4462 115.061 58.367 112.14 58.367 108.549V79.9334C58.367 76.3417 55.4462 73.4209 51.8555 73.4209H50.6331C47.0434 73.4209 44.1216 76.3417 44.1216 79.9334V108.549C44.1216 112.14 47.0434 115.061 50.6331 115.061Z",
    fill: "#FF5F3D"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8555 115.06H50.6331C49.8808 115.06 49.1586 114.931 48.4858 114.696C45.947 113.808 44.1216 111.388 44.1216 108.549V101.104C44.1216 104.694 47.0434 107.615 50.6331 107.615H51.8555C55.4462 107.615 58.367 104.694 58.367 101.104V108.549C58.367 112.139 55.4462 115.06 51.8555 115.06Z",
    fill: "#FF5F3D"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M58.367 82.415C58.367 78.8234 55.4462 75.9026 51.8555 75.9026H50.6331C47.0434 75.9026 44.1216 78.8234 44.1216 82.415V79.9334C44.1216 76.3417 47.0434 73.4209 50.6331 73.4209H51.8555C55.4462 73.4209 58.367 76.3417 58.367 79.9334V82.415Z",
    fill: "#FFBF08"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8318 89.0067V99.4724C34.8318 103.488 37.7894 106.828 41.6409 107.426V81.0537C37.7894 81.6518 34.8318 84.9914 34.8318 89.0067Z",
    fill: "#FFBF08"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6409 107.428C37.7894 106.83 34.8318 103.489 34.8318 99.4738V92.0288C34.8318 96.0441 37.7894 99.3847 41.6409 99.9828V107.428Z",
    fill: "#FFBF08"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8318 91.4884V89.0067C34.8318 84.9914 37.7894 81.6518 41.6409 81.0537V83.5354C37.7894 84.1335 34.8318 87.4731 34.8318 91.4884Z",
    fill: "#FFBF08"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M182.403 73.4209H181.179C177.591 73.4209 174.667 76.3417 174.667 79.9334V108.549C174.667 112.14 177.591 115.061 181.179 115.061H182.403C185.994 115.061 188.914 112.14 188.914 108.549V79.9334C188.914 76.3417 185.994 73.4209 182.403 73.4209Z",
    fill: "#FF5F3D"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M182.403 115.06H181.179C179.874 115.06 178.658 114.673 177.638 114.01C175.852 112.847 174.667 110.834 174.667 108.549V101.104C174.667 104.694 177.591 107.615 181.179 107.615H182.403C185.994 107.615 188.914 104.694 188.914 101.104V108.549C188.914 112.139 185.994 115.06 182.403 115.06Z",
    fill: "#FF5F3D"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M188.914 82.415C188.914 78.8234 185.994 75.9026 182.403 75.9026H181.179C177.591 75.9026 174.667 78.8234 174.667 82.415V79.9334C174.667 76.3417 177.591 73.4209 181.179 73.4209H182.403C185.994 73.4209 188.914 76.3417 188.914 79.9334V82.415Z",
    fill: "#FFBF08"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M193.716 79.0983C193.543 69.1599 191.513 59.5182 187.663 50.4233C183.775 41.2236 178.206 32.9672 171.115 25.877C169.028 23.7898 166.82 21.822 164.526 19.9946V20.998C182.154 35.2405 192.466 56.2475 192.935 78.853C193.2 78.9248 193.46 79.0072 193.716 79.0983Z",
    fill: "#FFF8E8"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M191.396 81.0537V107.426C195.248 106.828 198.206 103.488 198.206 99.4724V89.0067C198.206 84.9914 195.248 81.6518 191.396 81.0537Z",
    fill: "#FFBF08"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M191.396 107.428V99.9828C195.248 99.3847 198.206 96.0441 198.206 92.0288V99.4738C198.206 103.489 195.248 106.83 191.396 107.428Z",
    fill: "#FFBF08"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M198.206 91.4884C198.206 87.4731 195.248 84.1335 191.396 83.5354V81.0537C195.248 81.6518 198.206 84.9914 198.206 89.0067V91.4884Z",
    fill: "#FFBF08"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.0662,
    y: 108.191,
    width: 3.25742,
    height: 6.31024,
    rx: 1.62871,
    transform: "rotate(-6.95517 39.0662 108.191)",
    fill: "#333333"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M150.357 95.3035C149.35 97.7973 148.594 99.0939 147.083 99.8491C146.744 100.019 146.386 100.149 146.017 100.25C145.129 100.497 144.18 100.58 143.283 100.675C141.623 100.85 139.989 100.834 138.325 100.817C137.735 100.811 137.135 100.772 136.576 100.594C136.506 100.573 136.438 100.548 136.37 100.522C136.291 100.491 136.212 100.458 136.136 100.42C135.583 100.148 135.219 99.7055 134.957 99.1872C134.568 98.4182 134.405 97.4832 134.186 96.6971C134.108 96.4174 134.03 96.1366 133.95 95.8553C133.659 94.8217 133.369 93.7817 133.163 92.7315C132.962 91.7077 133.163 88.6858 133.599 87.6787C134.036 86.6715 135.648 82.8776 140.616 81.6694C145.585 80.4605 148.204 84.9931 149.681 86.8393C151.159 88.6858 151.364 92.8112 150.357 95.3035Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M148.355 94.2802C148.355 96.6421 147.455 98.768 146.017 100.25C145.129 100.497 144.18 100.581 143.283 100.675C141.623 100.85 139.989 100.835 138.325 100.818C137.735 100.811 137.135 100.772 136.576 100.594C136.506 100.573 136.438 100.548 136.37 100.522C136.291 100.492 136.212 100.458 136.136 100.42C135.583 100.148 135.219 99.7059 134.957 99.1877C134.568 98.4187 134.405 97.4836 134.186 96.6976C134.108 96.4179 134.03 96.1371 133.95 95.8558C133.903 95.338 133.883 94.8103 133.883 94.2802C133.883 89.8002 137.122 86.1685 141.119 86.1685C145.115 86.1685 148.355 89.8002 148.355 94.2802Z",
    fill: "#100F0D"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M134.471 87.3661C135.293 85.2185 137.061 83.4048 139.18 82.5389C140.437 82.0281 141.831 81.9213 143.158 82.1971C146.467 82.9123 149.223 85.624 150.236 88.8334C151.198 92.0529 150.569 95.4593 148.716 98.2454C148.442 98.6658 148.14 99.0694 147.801 99.4471C148.61 98.817 149.287 98.0333 149.869 97.1884C150.748 95.8937 151.356 94.4071 151.616 92.8588C151.859 91.4204 151.816 89.9164 151.489 88.494C150.684 85.1951 148.222 82.3521 145.086 81.0518C143.038 80.1958 140.614 80.1262 138.553 81.0072C136.026 82.0848 134 84.2818 133.149 86.8926C131.732 91.255 133.205 96.506 135.438 100.353C134.015 96.4336 132.935 91.3686 134.471 87.3661Z",
    fill: "#100F0D"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M138.708 91.1474C138.708 89.6576 139.994 88.4502 141.579 88.4502C143.164 88.4502 144.45 89.6576 144.45 91.1474C144.45 92.6371 143.164 93.8448 141.579 93.8448C139.994 93.8448 138.708 92.6371 138.708 91.1474Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M139.881 95.3658C139.881 94.9115 140.249 94.5435 140.704 94.5435C141.158 94.5435 141.527 94.9115 141.527 95.3658C141.527 95.8205 141.158 96.189 140.704 96.189C140.249 96.189 139.881 95.8205 139.881 95.3658Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M102.348 92.65C102.274 93.0278 102.187 93.4042 102.094 93.7787C101.899 94.5664 101.672 95.3488 101.458 96.1274C101.224 96.9744 101.067 98.0743 100.645 98.9521C100.637 98.9695 100.628 98.9875 100.618 99.0042C100.446 99.3452 100.214 99.6226 99.9401 99.8466C99.2239 100.434 98.2279 100.652 97.2811 100.666C96.0131 100.684 94.7667 100.485 93.5085 100.395C92.4679 100.32 91.4414 100.311 90.4304 100.099C90.1727 100.045 89.9164 99.9781 89.6612 99.8935C87.3991 99.1418 86.4573 97.223 85.6208 95.1522C84.6412 92.7276 84.841 88.7141 86.2783 86.9177C87.715 85.1215 90.2628 80.7119 95.0969 81.888C99.9312 83.0634 101.499 86.7545 101.923 87.7343C102.348 88.7141 102.544 91.654 102.348 92.65Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M102.103 94.1559C102.103 95.9841 101.549 97.6656 100.618 99.0038C100.41 99.3028 100.184 99.5844 99.9403 99.8462C99.2241 100.434 98.2281 100.652 97.2814 100.666C96.0134 100.684 94.7669 100.485 93.5087 100.394C92.4682 100.32 91.4417 100.311 90.4307 100.099C88.9549 98.652 88.0225 96.5268 88.0225 94.1559C88.0225 89.7974 91.1744 86.2642 95.0624 86.2642C98.8374 86.2642 101.919 89.595 102.094 93.7783C102.1 93.9038 102.103 94.0292 102.103 94.1559Z",
    fill: "#100F0D"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2406 96.9847C86.8063 97.8067 87.4644 98.5698 88.2519 99.1822C87.9224 98.8147 87.6287 98.4221 87.3616 98.0131C85.5594 95.3033 84.9475 91.9886 85.8835 88.8564C86.8687 85.7341 89.5499 83.096 92.7691 82.4002C94.0604 82.1319 95.4161 82.2358 96.6391 82.7327C98.7 83.5744 100.421 85.3401 101.221 87.4289C102.714 91.3216 101.663 96.2523 100.28 100.064C102.453 96.3166 103.885 91.2166 102.506 86.9683C101.679 84.4283 99.7068 82.2909 97.2491 81.2426C95.2437 80.3848 92.8861 80.4539 90.8934 81.286C87.8419 82.551 85.4477 85.3169 84.6647 88.5262C84.3467 89.9101 84.3045 91.3732 84.5404 92.7726C84.7932 94.2789 85.3847 95.7252 86.2406 96.9847Z",
    fill: "#100F0D"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M92.27 91.1079C92.27 89.6586 93.52 88.4839 95.0624 88.4839C96.6048 88.4839 97.8553 89.6586 97.8553 91.1079C97.8553 92.5572 96.6048 93.7321 95.0624 93.7321C93.52 93.7321 92.27 92.5572 92.27 91.1079Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1687 97.7612C97.1687 97.3824 97.4762 97.0757 97.8549 97.0757C98.2336 97.0757 98.5406 97.3824 98.5406 97.7612C98.5406 98.1402 98.2336 98.4474 97.8549 98.4474C97.4762 98.4474 97.1687 98.1402 97.1687 97.7612Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M130.245 77.7264C129.944 77.7264 129.61 77.5928 129.376 77.3589C128.942 76.891 128.942 76.1559 129.443 75.7215C132.317 73.0147 136.06 71.5444 140.003 71.5444C143.879 71.5444 147.588 72.9813 150.428 75.6212C150.896 76.0556 150.93 76.7908 150.495 77.2586C150.061 77.7264 149.326 77.7599 148.858 77.3254C146.452 75.12 143.311 73.8836 140.003 73.8836C136.661 73.8836 133.486 75.1534 131.047 77.4257C130.813 77.6262 130.546 77.7264 130.245 77.7264Z",
    fill: "#1E1E1E"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M103.558 77.7264C103.258 77.7264 102.99 77.6262 102.756 77.4257C100.317 75.1534 97.1425 73.8836 93.8009 73.8836C90.5261 73.8836 87.3849 75.12 84.9456 77.3254C84.4777 77.7599 83.7426 77.7264 83.3082 77.2586C82.8737 76.7908 82.9072 76.0556 83.375 75.6212C86.2154 73.0147 89.9246 71.5444 93.8009 71.5444C97.744 71.5444 101.487 73.0147 104.36 75.7215C104.828 76.1559 104.862 76.891 104.427 77.3589C104.16 77.6262 103.859 77.7264 103.558 77.7264Z",
    fill: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_412_8854)"
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0832 120.476C63.0832 120.476 99.4251 132.54 101.054 133.15C102.683 133.761 110.022 142.516 110.022 142.516C110.022 142.516 113.678 144.298 117.394 144.298C121.11 144.298 123.451 142.516 123.451 142.516C129.441 137.916 132.557 135.581 139.129 132.03L155.52 126.177L171.915 120.476L185.4 129.333L129.338 221.517L117.5 225L102.337 221.517L49.9985 129.333L63.0832 120.476Z",
    fill: "#624E17"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_412_8854",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 145,
    width: 19,
    height: 8
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M108.387 145.57H126.243V152.301H108.387V145.57Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_412_8854)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_412_8854",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 145,
    width: 19,
    height: 8
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M110.671 145.839L108.488 149.636C109.445 150.227 111.22 151.172 113.522 151.741C117.88 152.817 122.127 152.128 126.159 149.692L123.96 145.671C118.152 148.557 112.332 146.534 110.671 145.839Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_412_8854)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_412_8854",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 145,
    width: 19,
    height: 8
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M110.671 145.839L108.488 149.636C109.445 150.227 111.22 151.172 113.522 151.741C117.88 152.817 122.127 152.128 126.159 149.692L123.96 145.671C118.152 148.557 112.332 146.534 110.671 145.839Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_412_8854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.159 145.671H108.488V152.817H126.159V145.671Z",
    fill: "url(#paint2_linear_412_8854)"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_412_8854",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 125,
    y: 121,
    width: 54,
    height: 24
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M125.282 121.122H178.162V144.883H125.282V121.122Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_412_8854)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_412_8854",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 125,
    y: 121,
    width: 54,
    height: 24
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M174.196 122.968L161.872 126.92L172.643 122.152C171.871 121.747 171.209 121.397 170.769 121.164C170.399 121.29 169.87 121.471 169.216 121.695C168.859 121.864 168.638 121.951 168.59 121.968L168.569 121.916C162.497 124 148.219 128.917 142.349 131.104C135.991 133.473 127.354 140.144 125.379 141.707L125.42 142.112L126.897 144.813C132.649 141.068 168.719 128.252 178.044 124.968C176.926 124.395 175.515 123.659 174.196 122.968Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_412_8854)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_412_8854",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 125,
    y: 121,
    width: 54,
    height: 24
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M174.196 122.968L161.872 126.92L172.643 122.152C171.871 121.747 171.209 121.397 170.769 121.164C170.399 121.29 169.87 121.471 169.216 121.695C168.859 121.864 168.638 121.951 168.59 121.968L168.569 121.916C162.497 124 148.219 128.917 142.349 131.104C135.991 133.473 127.354 140.144 125.379 141.707L125.42 142.112L126.897 144.813C132.649 141.068 168.719 128.252 178.044 124.968C176.926 124.395 175.515 123.659 174.196 122.968Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_412_8854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.044 121.164H125.379V144.813H178.044V121.164Z",
    fill: "url(#paint3_linear_412_8854)"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_412_8854",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 125,
    width: 59,
    height: 24
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8757 125.929H107.151V148.592H49.8757V125.929Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_412_8854)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_412_8854",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 126,
    width: 58,
    height: 23
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M107.086 146.079L55.693 126.018L50.009 129.799L105.704 148.484L107.086 146.079Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_412_8854)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_412_8854",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 126,
    width: 58,
    height: 23
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M107.086 146.079L55.693 126.018L50.009 129.799L105.704 148.484L107.086 146.079Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_412_8854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.086 126.018H50.009V148.484H107.086V126.018Z",
    fill: "url(#paint4_linear_412_8854)"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_412_8854",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 120,
    width: 52,
    height: 25
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1555 120.984H108.8V144.883H57.1555V120.984Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_412_8854)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_412_8854",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 121,
    width: 52,
    height: 24
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M101.031 134.391C96.9929 131.75 78.003 125.623 65.9724 121.966V121.968L65.96 121.964C64.9487 121.656 63.9861 121.367 63.0864 121.097L60.1993 123.018L73.4538 128.357L58.7244 123.999L57.2119 125.005L107.84 144.768L108.712 143.252C108.243 140.534 105.417 137.258 101.031 134.391Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_412_8854)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_412_8854",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 121,
    width: 52,
    height: 24
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M101.031 134.391C96.9929 131.75 78.003 125.623 65.9724 121.966V121.968L65.96 121.964C64.9487 121.656 63.9861 121.367 63.0864 121.097L60.1993 123.018L73.4538 128.357L58.7244 123.999L57.2119 125.005L107.84 144.768L108.712 143.252C108.243 140.534 105.417 137.258 101.031 134.391Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_412_8854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.712 121.097H57.2119V144.768H108.712V121.097Z",
    fill: "url(#paint5_linear_412_8854)"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_412_8854",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: 125,
    width: 58,
    height: 24
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M127.617 125.792H184.343V148.455H127.617V125.792Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_412_8854)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_412_8854",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: 125,
    width: 58,
    height: 24
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M127.617 146.127L128.857 148.396C132.38 146.939 142.897 142.636 154.112 138.424C168.298 133.096 178.412 129.849 184.314 128.721C182.556 127.533 180.797 126.383 179.896 125.9C163.127 131.773 131.986 143.079 127.617 146.127Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_412_8854)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_412_8854",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: 125,
    width: 58,
    height: 24
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M127.617 146.127L128.857 148.396C132.38 146.939 142.897 142.636 154.112 138.424C168.298 133.096 178.412 129.849 184.314 128.721C182.556 127.533 180.797 126.383 179.896 125.9C163.127 131.773 131.986 143.079 127.617 146.127Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_412_8854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.314 125.9H127.617V148.396H184.314V125.9Z",
    fill: "url(#paint6_linear_412_8854)"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_412_8854",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: 131,
    width: 61,
    height: 92
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M127.617 131.285H187.64V222.624H127.617V131.285Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_412_8854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127 222.187C130.357 220.891 138.439 217.902 141.869 217.23C141.059 213.814 140.449 209.887 140.449 205.278C140.449 197.128 143.371 189.623 148.677 184.145C151.314 181.423 154.415 179.318 157.816 177.897C155.723 175.404 152.101 169.454 154.131 159.69C155.051 155.268 158.157 151.818 162.875 149.978C168.596 147.745 175.852 148.147 181.031 150.817L187.007 131C178.029 131.419 143.761 144.917 129.384 150.877L127 222.187Z",
    fill: "#FF5F3D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_412_8854",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 152,
    width: 20,
    height: 74
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M108 152H127.229V225.483H108V152Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_412_8854)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_412_8854",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 107,
    y: 152,
    width: 20,
    height: 75
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M112.672 154.61C110.723 154.115 109.109 153.397 107.941 152.772L110.208 223.726L116.462 226.052L124.605 223.485L126.974 152.674C123.528 154.582 120.256 155.212 117.441 155.212C115.638 155.212 114.025 154.955 112.672 154.61Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_412_8854)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask18_412_8854",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 107,
    y: 152,
    width: 20,
    height: 75
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M112.672 154.61C110.723 154.115 109.109 153.397 107.941 152.772L110.208 223.726L116.462 226.052L124.605 223.485L126.974 152.674C123.528 154.582 120.256 155.212 117.441 155.212C115.638 155.212 114.025 154.955 112.672 154.61Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_412_8854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127 152H108L109 223C109 223 112.5 225 116.5 225C120.5 225 124.5 223 124.5 223L127 152Z",
    fill: "#FF5F3D"
  }))))), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7098 134.45C46.5525 133.806 104.724 150.929 104.724 150.929L106.227 222.701L63.1026 204.957C63.1026 204.957 52.867 135.093 49.7098 134.45Z",
    fill: "#FF5F3D"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M186.266 131.767L129.716 151.616L126.13 223.25L169.921 206.692L186.266 131.767Z",
    fill: "#FF5F3D"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M121.506 207.259L121.525 208.807C121.527 208.944 121.489 209.06 121.411 209.155C121.325 209.243 121.228 209.294 121.12 209.31L114.238 210.393L114.206 210.393C114.141 210.394 114.087 210.373 114.043 210.33C113.992 210.28 113.966 210.223 113.965 210.158L113.939 208.145C113.936 207.907 114.032 207.776 114.227 207.751L117.274 207.345L115.916 206.918C115.706 206.849 115.6 206.728 115.597 206.554L115.583 205.45C115.581 205.277 115.684 205.153 115.893 205.078L117.229 204.618L114.183 204.288C113.988 204.269 113.889 204.14 113.886 203.902L113.861 201.889C113.86 201.824 113.885 201.77 113.935 201.726C113.977 201.675 114.031 201.649 114.096 201.648L114.128 201.648L121.035 202.557C121.144 202.57 121.242 202.622 121.33 202.715C121.41 202.801 121.451 202.912 121.453 203.049L121.472 204.597C121.475 204.821 121.38 204.97 121.186 205.044L118.978 205.96L121.208 206.819C121.404 206.889 121.503 207.036 121.506 207.259ZM118.981 201.046L118.245 201.055C117.423 201.066 116.788 200.781 116.34 200.202C115.893 199.623 115.663 198.872 115.651 197.949C115.64 197.025 115.85 196.268 116.283 195.678C116.716 195.088 117.344 194.788 118.166 194.778L118.902 194.769C119.732 194.758 120.37 195.032 120.818 195.589C121.258 196.146 121.484 196.908 121.496 197.875C121.508 198.842 121.301 199.61 120.875 200.178C120.442 200.746 119.811 201.036 118.981 201.046ZM119.022 197.419L118.113 197.431C117.839 197.434 117.648 197.473 117.541 197.546C117.433 197.62 117.381 197.747 117.383 197.927C117.385 198.107 117.441 198.233 117.55 198.304C117.659 198.374 117.851 198.408 118.125 198.405L119.034 198.393C119.323 198.39 119.517 198.351 119.618 198.278C119.718 198.204 119.767 198.077 119.764 197.897C119.762 197.717 119.706 197.591 119.597 197.52C119.488 197.449 119.296 197.416 119.022 197.419ZM118.895 194.223L118.159 194.232C117.337 194.243 116.702 193.959 116.254 193.38C115.807 192.801 115.577 192.049 115.566 191.126C115.554 190.202 115.765 189.446 116.197 188.856C116.63 188.266 117.258 187.965 118.08 187.955L118.816 187.946C119.646 187.935 120.285 188.209 120.732 188.766C121.172 189.323 121.398 190.085 121.41 191.052C121.422 192.019 121.215 192.787 120.79 193.355C120.357 193.923 119.725 194.213 118.895 194.223ZM118.936 190.596L118.027 190.608C117.753 190.611 117.562 190.65 117.455 190.723C117.348 190.797 117.295 190.924 117.297 191.104C117.3 191.284 117.355 191.41 117.464 191.481C117.574 191.552 117.765 191.585 118.039 191.582L118.949 191.57C119.237 191.567 119.432 191.528 119.532 191.455C119.632 191.381 119.681 191.255 119.678 191.074C119.676 190.894 119.62 190.768 119.511 190.697C119.402 190.627 119.211 190.593 118.936 190.596ZM117.927 180.927L118.782 180.917C119.634 180.906 120.268 181.111 120.684 181.531C121.094 181.952 121.303 182.505 121.311 183.191C121.32 183.876 121.085 184.409 120.606 184.791L120.931 184.787C121.01 184.786 121.079 184.814 121.138 184.871C121.196 184.928 121.226 184.996 121.227 185.075L121.25 186.915C121.251 186.994 121.223 187.063 121.166 187.122C121.109 187.18 121.041 187.21 120.961 187.211L113.861 187.3C113.782 187.301 113.713 187.273 113.655 187.216C113.596 187.159 113.566 187.091 113.565 187.012L113.54 185.009C113.539 184.93 113.567 184.861 113.624 184.803C113.681 184.744 113.749 184.715 113.829 184.714L115.993 184.686C115.65 184.315 115.474 183.82 115.466 183.199C115.458 182.571 115.664 182.038 116.085 181.6C116.505 181.162 117.119 180.938 117.927 180.927ZM118.764 184.651C119.183 184.646 119.39 184.463 119.385 184.102C119.381 183.742 119.169 183.564 118.751 183.569L118.036 183.578C117.618 183.583 117.411 183.766 117.415 184.127C117.42 184.466 117.602 184.644 117.963 184.662L118.764 184.651ZM121.137 177.954L121.162 179.891C121.163 179.971 121.135 180.04 121.078 180.098C121.021 180.157 120.952 180.186 120.873 180.187L113.773 180.277C113.694 180.278 113.625 180.25 113.566 180.193C113.508 180.136 113.478 180.067 113.477 179.988L113.453 178.051C113.452 177.971 113.48 177.902 113.537 177.844C113.594 177.786 113.662 177.756 113.741 177.755L120.841 177.666C120.921 177.665 120.99 177.693 121.048 177.75C121.106 177.807 121.136 177.875 121.137 177.954ZM121.095 174.566L121.119 176.504C121.12 176.583 121.092 176.652 121.035 176.71C120.978 176.769 120.91 176.799 120.83 176.8L113.73 176.889C113.651 176.89 113.582 176.862 113.524 176.805C113.465 176.748 113.435 176.68 113.434 176.6L113.41 174.663C113.409 174.584 113.437 174.515 113.494 174.456C113.551 174.398 113.619 174.368 113.699 174.367L120.799 174.278C120.878 174.277 120.947 174.305 121.005 174.362C121.064 174.419 121.094 174.487 121.095 174.566ZM115.453 173.587L115.43 171.758C115.428 171.592 115.513 171.476 115.686 171.408L118.142 170.49L115.663 169.601C115.489 169.531 115.401 169.409 115.399 169.236L115.376 167.429C115.375 167.364 115.4 167.306 115.449 167.255C115.492 167.204 115.539 167.178 115.589 167.177C115.64 167.177 115.679 167.18 115.708 167.186L122.836 170.149C123.01 170.219 123.098 170.345 123.1 170.525L123.123 172.3C123.124 172.365 123.103 172.423 123.06 172.474C123.017 172.518 122.963 172.54 122.898 172.541C122.841 172.542 122.805 172.539 122.79 172.532L120.701 171.692L115.792 173.843C115.771 173.85 115.745 173.854 115.716 173.855C115.543 173.828 115.455 173.739 115.453 173.587Z",
    fill: "#FFF8E8",
    fillOpacity: 0.9
  }))), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M151.755 108.193C151.755 109.271 149.273 110.142 146.211 110.142C143.149 110.142 140.667 109.271 140.667 108.193C140.667 107.117 143.149 106.244 146.211 106.244C149.273 106.244 151.755 107.117 151.755 108.193Z",
    fill: "#FF5F3D"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4785 108.193C95.4785 109.271 92.9967 110.142 89.9347 110.142C86.8719 110.142 84.3901 109.271 84.3901 108.193C84.3901 107.117 86.8719 106.244 89.9347 106.244C92.9967 106.244 95.4785 107.117 95.4785 108.193Z",
    fill: "#FF5F3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_412_8854",
    x: 0.912186,
    y: 0,
    width: 241.567,
    height: 249.092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.47893
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.73946
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_412_8854"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_412_8854",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_412_8854",
    x: 38.3472,
    y: 112.697,
    width: 30.8453,
    height: 96.0653,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.44816
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.22408
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_412_8854"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_412_8854",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_412_8854",
    x: 44.2024,
    y: 120.476,
    width: 148.188,
    height: 115.291,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.38329
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.69165
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_412_8854"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_412_8854",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_412_8854",
    x1: 115.03,
    y1: 113.664,
    x2: 112.229,
    y2: 204.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5F3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_412_8854",
    x1: 116.587,
    y1: 44.7912,
    x2: 116.587,
    y2: -3.91379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5F3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_412_8854",
    x1: 117.324,
    y1: 145.671,
    x2: 117.324,
    y2: 152.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F3F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#F3F4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#F2F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#F2F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#F1F2F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#F0F1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#EEF0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#EEEFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#EDEFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#EDEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#ECEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#ECEDEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ECEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#EBECEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#EAEBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#EAEBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#E9EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#E8EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#E8E9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#E7E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#E7E8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#E6E8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#E6E7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#E5E6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#E5E6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#E4E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#E4E5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#E3E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#E2E4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#E2E3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#E2E3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#E1E2E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#E0E1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#E0E1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#E0E0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#DFDFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#DEDFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#DDDDDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#DCDDDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#DCDCDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#DBDCDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#DBDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#DADAD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#D9DAD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#D9D9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#D8D8D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#D7D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#D7D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#D6D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#D5D6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#D5D6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#D5D5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#D4D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#D4D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#D3D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#D2D3D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#D2D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#D1D2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#D1D2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#D0D1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#D0D1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#CFD0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#CFD0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#CFCFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CECECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#CDCECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#CDCDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#CCCDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#CCCCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#CBCCC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#CBCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#CACAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CACAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#C9C9C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#C8C8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#C8C8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#C7C8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#C7C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#C6C6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#C6C6C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#C5C5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#C5C5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#C4C4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#C4C4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#C3C3C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C2C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_412_8854",
    x1: 151.711,
    y1: 121.163,
    x2: 151.711,
    y2: 144.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#F3F5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#F3F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F2F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#F2F3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#F1F2F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F0F1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#EEF0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#EEF0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#EDEFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#EDEFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#ECEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ECEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257813,
    stopColor: "#ECEDEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#ECEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#EBECEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#EBECEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#EAEBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304687,
    stopColor: "#EAEBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#E9EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#E9EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#E8EAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335937,
    stopColor: "#E7E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#E7E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#E7E8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367187,
    stopColor: "#E6E7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#E6E7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#E5E6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#E5E6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#E4E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#E4E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#E3E5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#E3E4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#E2E3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#E2E3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#E2E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#E1E2E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#E0E1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E0E0DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#DFE0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#DFDFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#DEDEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#DEDEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#DDDDDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#DCDDDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#DCDCDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#DBDCDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#DBDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#DADAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#D9DAD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#D9D9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#D8D8D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#D8D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#D7D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#D7D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#D6D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#D6D6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#D5D6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#D5D5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#D4D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#D4D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#D3D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#D3D3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#D2D3D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D1D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#D1D2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#D1D2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#D0D1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#D0D1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#CFD0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#CFD0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#CFCFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CFCFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#CECECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#CDCDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#CCCDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#CCCDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#CBCCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#CBCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#CBCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#CBCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#CACAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#CACAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#C9C9C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#C9C9C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#C8C8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#C8C8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#C7C8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#C7C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#C6C6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#C6C6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#C6C6C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#C5C5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#C5C5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#C4C4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#C4C4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#C3C3C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C3C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_412_8854",
    x1: 78.5468,
    y1: 126.017,
    x2: 78.5468,
    y2: 148.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132813,
    stopColor: "#F3F5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#F3F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F2F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164063,
    stopColor: "#F2F3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179687,
    stopColor: "#F1F2F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F0F1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195313,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210937,
    stopColor: "#EEF0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#EEF0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#EDEFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#EDEFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242187,
    stopColor: "#ECEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ECEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#ECEDEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#ECEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#EBECEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#EBECEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#EAEBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#EAEBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#E9EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#E9EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#E8EAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#E7E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#E7E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#E7E8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#E6E7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#E6E7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#E5E6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#E5E6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#E4E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#E4E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#E3E5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#E3E4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#E2E3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#E2E3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#E1E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#E1E2E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#E0E1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E0E0DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507813,
    stopColor: "#DFE0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#DFDFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#DEDEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#DEDEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#DDDDDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#DCDDDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#DCDCDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#DBDCDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#DBDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#DADAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#D9DAD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#D9D9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632813,
    stopColor: "#D8D8D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#D8D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#D7D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#D7D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#D6D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#D6D6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#D5D6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#D5D5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#D4D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#D4D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#D3D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#D3D3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#D2D3D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D1D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    stopColor: "#D1D2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#D1D2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#D0D1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#D0D1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#CFD0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#CFD0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#CFCFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CFCFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#CECECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#CDCDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#CCCDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#CCCDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#CBCCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#CBCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#CBCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#CBCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#CACAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882813,
    stopColor: "#CACAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#C9C9C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#C9C9C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#C8C8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#C8C8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#C7C8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#C7C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#C6C6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#C6C6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#C6C6C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#C5C5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#C5C5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#C4C4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#C4C4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#C3C3C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C3C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_412_8854",
    x1: 82.9626,
    y1: 121.097,
    x2: 82.9626,
    y2: 144.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#F3F5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#F3F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F2F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#F2F3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#F1F2F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F0F1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#EEF0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#EEF0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#EDEFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#EDEFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#ECEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ECEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#ECEDEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#ECEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#EBECEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#EBECEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#EAEBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#EAEBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#E9EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#E9EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#E8EAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#E7E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#E7E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#E7E8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#E6E7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#E6E7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#E5E6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#E5E6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#E4E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#E4E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#E3E5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#E3E4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#E2E3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#E2E3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#E1E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#E1E2E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#E0E1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E0E0DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#DFE0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#DFDFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#DEDEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#DEDEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#DDDDDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#DCDDDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#DCDCDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#DBDCDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#DBDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#DADAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#D9DAD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#D9D9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#D8D8D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#D8D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#D7D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#D7D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664063,
    stopColor: "#D6D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#D6D6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#D5D6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#D5D5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#D4D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#D4D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#D3D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#D3D3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#D2D3D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D1D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#D1D2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#D1D2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#D0D1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#D0D1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#CFD0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#CFD0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#CFCFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CFCFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#CECECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#CDCDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#CCCDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "#CCCCCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#CBCCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#CBCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#CBCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#CBCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#CACAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#CACAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#C9C9C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#C9C9C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#C8C8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914063,
    stopColor: "#C8C8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#C7C8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#C7C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#C6C6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#C6C6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#C6C6C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960937,
    stopColor: "#C5C5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#C5C5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#C4C4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#C4C4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#C3C3C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C3C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_412_8854",
    x1: 155.966,
    y1: 125.9,
    x2: 155.966,
    y2: 148.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#F3F5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#F3F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F2F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#F2F3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#F1F2F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F0F1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#EEF0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#EEF0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#EDEFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#EDEFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#ECEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ECEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#ECEDEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#ECEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#EBECEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#EBECEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#EAEBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#EAEBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#E9EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#E9EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#E8EAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335937,
    stopColor: "#E7E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#E7E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#E7E8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#E6E7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#E6E7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#E5E6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#E5E6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#E4E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#E4E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#E3E5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#E3E4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#E2E3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#E2E3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#E1E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#E1E2E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#E0E1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E0E0DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#DFE0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#DFDFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#DEDEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#DEDEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554687,
    stopColor: "#DDDDDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#DCDDDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570313,
    stopColor: "#DCDCDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#DBDCDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#DBDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#DADAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#D9DAD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#D9D9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#D8D8D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#D8D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#D7D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#D7D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#D6D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#D6D6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#D5D6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    stopColor: "#D5D5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#D4D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#D4D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#D3D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#D3D3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#D2D3D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D1D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#D1D2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#D1D2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#D0D1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#D0D1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#CFD0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#CFD0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804687,
    stopColor: "#CFCFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CFCFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#CECECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#CDCDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#CCCDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#CCCCCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#CBCCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#CBCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#CBCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#CBCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#CACAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#CACAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#C9C9C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#C9C9C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#C8C8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#C8C8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#C7C8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#C7C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#C6C6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945313,
    stopColor: "#C6C6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#C6C6C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#C5C5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#C5C5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#C4C4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#C4C4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#C3C3C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C3C1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWooblly);
export default __webpack_public_path__ + "static/media/wooblly.ae46f61eecdba37f63d71ef8baac5fac.svg";
export { ForwardRef as ReactComponent };